export default {
    "1": "切换会话",
    "2": "切换会话并滚动值顶部",
    "3": "定位某一条会话功能",
    "4": "定位某一条准确消息功能",
    "5": "定位某一条会话不需要检查群公告编辑状态以及窗口状态",
    "6": "定位某一条会话不需要检查窗口状态",
    "7": "站内信",
    "8": "邮件",
    "9": "短信",
    "10": "全部",
    "11": "企业客户",
    "12": "自然人客户",
    "13": "中介机构",
    "14": "潜在客户",
    "15": "已投客户",
    "16": "初步洽谈",
    "17": "达成合作",
    "18": "协议签署",
    "19": "会计师事务所",
    "20": "律师事务所",
    "21": "资产评估机构",
    "22": "信用评级机构",
    "23": "券商机构",
    "24": "未上市",
    "25": "主板",
    "26": "中小板",
    "27": "创业板",
    "28": "新三板",
    "29": "科创板",
    "30": "其他",
    "31": "自然人",
    "32": "法人",
    "33": "已通过",
    "34": "审批中",
    "35": "未通过",
    "36": "已撤销",
    "37": "有条件通过",
    "38": "暂缓表决",
    "39": "普通",
    "40": "紧急",
    "41": "非常紧急",
    "42": "正常",
    "43": "已逾期",
    "44": "未完成",
    "45": "已完成",
    "46": "已关闭",
    "47": "未读",
    "48": "已读",
    "49": "登录状态已失效需要跳到登录页面",
    "50": "登录过期，请重新登录！",
    "51": "网络异常！",
    "52": "项目id不存在 如果看到此错误 请在群里说一下复现步骤",
    "53": "userId为空 如果看到此错误 请在群里说一下复现步骤",
    "54": "任务已删除",
    "55": "名称中不能包含下列特殊字符“\\\\/:*?\"<>|”",
    "56": "暂无对应权限，请联系管理员！",
    "57": "当前无选中文件或文件夹",
    "58": "独立窗口数量已达上限，请关闭其他已打开窗口再操作",
    "59": "项目不存在",
    "60": "组织不存在",
    "61": "荣大XB文件不允许更新版本，请选择重命名或跳过",
    "62": "存在文件与文件夹重名，请选择重命名或跳过",
    "63": "提示",
    "64": "确定要取消上传所有文件吗？",
    "65": "确定",
    "66": "取消",
    "67": "文件已被删除",
    "68": "确定解除「手动锁定」的文件吗？",
    "69": "解除锁定后将通过站内信向锁定人「{}」发送文件解锁提醒。确定继续解锁吗？",
    "70": "解锁",
    "71": "暂无权限解除他人「手动锁定」的文件",
    "72": "请联系锁定人 【{}】进行解除锁定",
    "73": "解锁失败",
    "74": "我知道了",
    "75": "确定（{}秒）",
    "76": "确定要解锁该文件吗？",
    "77": "该文件可能正在编辑，解锁后，完成的版本需要手动上传，同时手动上传的版本内容将覆盖他人编辑的内容，确定要解锁吗？",
    "78": "确定解锁此文件吗？",
    "79": "检测到此文件未在编辑状态，文件锁定异常。",
    "80": "如确定文件正在编辑，请在完成编辑后检查文件已更新为编辑内容。确定继续解锁吗？",
    "81": "暂无权限解除他人正在进行「本地编辑」的文件。",
    "82": "不支持手动解除「审批中/审批通过」的文件",
    "83": "当文件审批被驳回或审批通过后，发起修订时将自动解锁",
    "84": "此文件正在被{}人编辑，不支持解锁他人正在进行「在线编辑」的文件，文件将在所有人完成编辑后自动解锁。",
    "85": "文件锁定异常，且无人正在编辑当前文件，确定要继续解锁吗？",
    "86": "文件锁定异常，且无人正在编辑当前文件，请联系项目管理员进行解锁",
    "87": "联系项目管理员",
    "88": "此文件已被系统锁定，可以预览/只读方式打开！",
    "89": "如需要编辑文件，请下载文件至本地。",
    "90": "此文件已经被",
    "91": "锁定，可以预览/只读方式打开！",
    "92": "文件大于 1G 不支持在线编辑！",
    "93": "文件正在进行本地编辑，请先保存后再进行在线编辑操作！",
    "94": "知道了",
    "95": "该文件已锁定，解锁后才能进行编辑，确定要解锁并进行编辑吗？",
    "96": "该文件格式不支持在线编辑，请通过本地编辑或下载后编辑！",
    "97": "文件正在进行在线编辑，请先保存后再进行本地编辑操作！",
    "98": "参数校验失败，请联系管理员！",
    "99": "网络异常",
    "100": "荣大智慧云",
    "101": "预览",
    "102": "该文件类型暂不支持预览，请下载查看！",
    "103": "【荣大智慧云】的下载文件.xlsx",
    "104": "文档导出错误",
    "105": "搜狗",
    "106": "当前项目已终止，不可进行此操作",
    "107": "服务繁忙，请稍后重试",
    "108": "获取行业分类错误， \\'{}",
    "109": "正在打开页面。。。",
    "110": "获取媒体信息错误，请稍后再试。",
    "111": "编辑",
    "112": "只读查看",
    "113": "请下载查看！",
    "114": "是否通过本地应用打开查看？",
    "115": "是否下载到本地？",
    "116": "下载",
    "117": "只读打开",
    "118": "此文件类型暂不支持编辑与预览，可通过“只读”方式打开文件或将文件下载至本地查看。",
    "119": "只读",
    "120": "当前上传图片已超过最大限制",
    "121": "今天",
    "122": "昨天",
    "123": "前天",
    "124": "MM月DD日",
    "125": "YYYY年MM月DD日",
    "126": "该附件已被删除",
    "127": "我的日志",
    "128": "确定要复用日志吗？",
    "129": "确定要新建日志吗？",
    "130": "有正在编辑的草稿内容，该操作将清空已有的草稿内容，确定继续操作吗？",
    "131": "编辑草稿",
    "132": "网络异常，请刷新重试",
    "133": "共移动 {} 个文件",
    "134": "我是目标文件",
    "135": "目标文件夹与源文件夹相同",
    "136": "目标文件夹含有源文件夹的子文件夹",
    "137": "目标文件夹为\"全部\"文件夹",
    "138": "文件无法操作，已选中的文件或文件夹包含已锁定状态",
    "139": "选中数量超过{}条，请减少操作数量",
    "140": "移动 {} 个文件",
    "141": "发送指定聊天",
    "142": "发送至项目聊天",
    "143": "全局检索",
    "144": "无对应权限，请联系对应项目组负责人处理",
    "145": "系统异常，请刷新重试",
    "146": "当前无权限",
    "147": "{}已存在",
    "148": "文件夹",
    "149": "文件",
    "150": "\"{}\"于{}正在编辑文件",
    "151": "\"{}\"于{}锁定文件",
    "152": "{}审批通过已被锁定",
    "153": "\"{}\"于{}对该{}发起审批",
    "154": "未正常退出，请重新双击进入编辑，待所有人再次退出后系统自动解锁",
    "155": "多人在线编辑模式",
    "156": "单人本地编辑",
    "157": "该文件切换模式错误，请检查网络无问题后重试",
    "158": "当前最多仅支持选择 {} 人，超出人员不计入选择！",
    "159": "文件夹名称包含特殊字符，请修改文件夹名称后再上传",
    "160": "文件名称包含特殊字符，请修改文件名称后再上传",
    "161": "无内容",
    "162": "文件超出下载限制（已超出600MB/不支持多文件下载），建议使用荣大智慧云客户端进行下载",
    "163": "未检测到荣大智慧云客户端，如果未安装客户端，请先下载安装",
    "164": "下载荣大智慧云客户端",
    "165": "重新检测本地客户端",
    "166": "下载Apple芯片版本",
    "167": "下载Intel芯片版本",
    "168": "正在启动，请稍后",
    "169": "附件",
    "170": "删除失败",
    "171": "已选中的内容中包含已锁定的文件，请先解锁后再进行删除",
    "172": "去解锁",
    "173": "请先加入项目群",
    "174": "消息",
    "175": "项目",
    "176": "文档",
    "177": "任务",
    "178": "工作台",
    "179": "通讯录",
    "180": "投关",
    "181": "应用中心",
    "182": "项目列表",
    "183": "项目归档库",
    "184": "项目终止库",
    "185": "项目回收站",
    "186": "标签管理",
    "187": "项目文档",
    "188": "底稿视图",
    "189": "回收站",
    "190": "文件收藏",
    "191": "个人网盘",
    "192": "我的任务",
    "193": "项目任务",
    "194": "主页",
    "195": "项目统计",
    "196": "日历表",
    "197": "待办事项",
    "198": "我的审批",
    "199": "我的会议",
    "200": "我的投票",
    "201": "我的客户",
    "202": "客户联系人",
    "203": "拜访记录",
    "204": "项目成员",
    "205": "项目日志",
    "206": "项目信息",
    "207": "项目审批",
    "208": "项目会议",
    "209": "项目投票",
    "210": "打开独立窗口",
    "211": "从导航栏移除",
    "212": "设为首页打开",
    "213": "显示应用名称",
    "214": "自定义导航菜单",
    "215": "定位",
    "216": "另存为",
    "217": "打开",
    "218": "投票详情",
    "219": "所属项目",
    "220": "投票名称",
    "221": "投票类型",
    "222": "投票时间",
    "223": "提醒方式",
    "224": "投票人员",
    "225": "抄送人员",
    "226": "日程名称",
    "227": "人员",
    "228": "时间",
    "229": "重复",
    "230": "内容",
    "231": "抄送人",
    "232": "任务详情",
    "233": "任务名称",
    "234": "截止时间",
    "235": "项目名称",
    "236": "状态",
    "237": "创建时间",
    "238": "会议详情",
    "239": "参会人员",
    "240": "列席人员",
    "241": "会议主题",
    "242": "会议类型",
    "243": "会议地点",
    "244": "会议抄送人",
    "245": "会议内容",
    "246": "日程",
    "247": "投票",
    "248": "会议",
    "249": "日志",
    "250": "修改",
    "251": "无提醒",
    "252": "提前15分钟",
    "253": "提前1小时",
    "254": "提前3小时",
    "255": "提前1天",
    "256": "不重复",
    "257": "每天",
    "258": "每周",
    "259": "每年",
    "260": "工作日",
    "261": "不提醒",
    "262": "截至前15分钟",
    "263": "截至前1小时",
    "264": "截至前3小时",
    "265": "截至前1天",
    "266": "剪切",
    "267": "复制",
    "268": "重命名",
    "269": "删除",
    "270": "粘贴",
    "271": "预览打开",
    "272": "多人编辑",
    "273": "通过浏览器在线打开该文件，支持多人同时编辑",
    "274": "发送到指定聊天",
    "275": "发送到项目聊天",
    "276": "发送到聊天",
    "277": "Excel格式",
    "278": "外链分享",
    "279": "生成文件链接，任意人员可通过该链接预览、下载该文件",
    "280": "上传新版本",
    "281": "版本",
    "282": "属性",
    "283": "操作日志",
    "284": "锁定",
    "285": "锁定当前文件，文件被锁定后他人不可编辑",
    "286": "保存到个人网盘",
    "287": "解除锁定，编辑过程中不建议解锁，否则将导致现有编辑内容无法保存上传",
    "288": "添加至「文件收藏」",
    "289": "批量上锁",
    "290": "批量解锁",
    "291": "解锁当前所选文件,以及文件夹下所有的文件",
    "292": "文件审批",
    "293": "文件标签",
    "294": "关联底稿",
    "295": "文件审批意见",
    "296": "文件修订",
    "297": "关联索引列表",
    "298": "设置提醒",
    "299": "核查备注",
    "300": "本地编辑",
    "301": "使用本地编辑器打开该文件，仅支持单人编辑",
    "302": "打开任务",
    "303": "新建文件夹",
    "304": "新建任务文件夹",
    "305": "上传文件",
    "306": "上传文件夹",
    "307": "Word文档",
    "308": "Excel表格",
    "309": "PPT演示",
    "310": "导出清洁版",
    "311": "新建文件",
    "312": "目录审批",
    "313": "目录审批意见",
    "314": "目录修订",
    "315": "更多",
    "316": "下载核查报告",
    "317": "文件工具箱介绍",
    "318": "Excel检验文件目录",
    "319": "Excel提取并复制文件",
    "320": "导出文件目录",
    "321": "文件工具箱",
    "322": "该部门已被删除",
    "323": "有文件正在上传，页面切换或刷新将导致文件上传取消。是否继续？",
    "324": "定制页面切换普通页面",
    "325": "普通页面切换到定制页面",
    "326": "定制页面跳转至定制页面",
    "327": "上市公司",
    "328": "拟上市公司",
    "329": "有限责任公司",
    "330": "股份有限公司",
    "331": "股份合作企业",
    "332": "国有企业",
    "333": "集体所有制",
    "334": "个体工商户",
    "335": "独资企业",
    "336": "有限合伙",
    "337": "普通合伙",
    "338": "外商投资企业",
    "339": "港、澳、台商投资企业",
    "340": "联营企业",
    "341": "私营企业",
    "342": "其他浏览器",
    "343": "项目类型",
    "344": "普通审批",
    "345": "审批流程名称",
    "346": "审批类型",
    "347": "业务类型",
    "348": "项目阶段",
    "349": "流程描述",
    "350": "是否可用",
    "351": "可用",
    "352": "不可用",
    "353": "不可用原因",
    "354": "请输入审批流程名称",
    "355": "请选择审批类型",
    "356": "底稿审批",
    "357": "阶段审批",
    "358": "项目终止审批",
    "359": "新建项目审批",
    "360": "底稿归档审批",
    "361": "底稿借阅审批",
    "362": "文件修订审批",
    "363": "底稿目录修订审批",
    "364": "无",
    "365": "项目所属阶段与流程图所属业务类型不匹配",
    "366": "待审文件",
    "367": "请到项目文档中发起审批",
    "368": "项目所属阶段与流程图所属阶段不匹配",
    "369": "当前项目正在进行阶段审核",
    "370": "这是个错误提示！",
    "371": "这是个正确提示！",
    "372": "当前账号在其他设备登录，如果不是本人操作，请及时修改登录密码",
    "373": "登录状态已失效，需要跳转登录页面重新登录",
    "374": "图片",
    "375": "群公告",
    "376": "分享了一个任务",
    "377": "重置数据",
    "378": "单独设置某一个会话",
    "379": "批量设置会话操作",
    "380": "单条会话移除",
    "381": "免打扰状态切换",
    "382": "接受某条消息后处理",
    "383": "重新登录后对托盘所有消息进行重置",
    "384": "会话已读的操作,需要删除与sessionid相关忽略、@消息、托盘等数据",
    "385": "全部任务",
    "386": "全部项目",
    "387": "消息会话",
    "388": "消息记录",
    "389": "讨论文件合集",
    "390": "Word文件（非XB）",
    "391": "表格文件",
    "392": "演示文件",
    "393": "PDF文件",
    "394": "TXT文件",
    "395": "图片文件",
    "396": "视频文件",
    "397": "音频文件",
    "398": "荣大XB文件",
    "399": "外部XB文件",
    "400": "其它",
    "401": "有索引的",
    "402": "无索引的",
    "403": "已锁定",
    "404": "有备注的",
    "405": "有标签的",
    "406": "待审批",
    "407": "审批通过",
    "408": "节点审批通过",
    "409": "驳回未修改",
    "410": "驳回已修改",
    "411": "修订中",
    "412": "修订审批中",
    "413": "有关联的",
    "414": "有审批记录的",
    "415": "有设置提醒的",
    "416": "已归档",
    "417": "无文件",
    "418": "有文件",
    "419": "引用目录",
    "420": "非引用目录",
    "421": "项目名称或项目ID",
    "422": "项目创建人",
    "423": "选择部门",
    "424": "项目地区",
    "425": "当前阶段",
    "426": "创建日期",
    "427": "关联客户",
    "428": "关联项目",
    "429": "行业分类",
    "430": "项目负责人",
    "431": "文件名称",
    "432": "标题关键词",
    "433": "内容关键词",
    "434": "文件类型",
    "435": "文件状态",
    "436": "目录状态",
    "437": "修改时间起",
    "438": "修改时间止",
    "439": "创建人",
    "440": "执行人",
    "441": "优先级",
    "442": "逾期状态",
    "443": "任务状态",
    "444": "任务时间起",
    "445": "任务时间止",
    "446": "日志标题",
    "447": "日志内容",
    "448": "发出人员",
    "449": "日志状态",
    "450": "日志评论",
    "451": "日志评论人",
    "452": "日志接收人",
    "453": "个人日志",
    "454": "客户编码",
    "455": "客户名称",
    "456": "客户类型",
    "457": "客户状态",
    "458": "上市板块",
    "459": "客户负责人",
    "460": "客户创建人",
    "461": "机构编码",
    "462": "机构名称",
    "463": "机构简称",
    "464": "机构类型",
    "465": "部门",
    "466": "职务",
    "467": "拜访开始时间",
    "468": "拜访结束时间",
    "469": "拜访地点",
    "470": "拜访人员",
    "471": "拜访形式",
    "472": "主要成果",
    "473": "请输入项目名称,多个请用空格隔开",
    "474": "请选择项目成员",
    "475": "请选择阶段",
    "476": "点击选择项目创建人",
    "477": "点击选择项目负责人",
    "478": "请选择起始时间",
    "479": "请选择终止时间",
    "480": "请输入客户名称,多个请用空格隔开",
    "481": "共 {} 条 (最多可查看前 10,000 条数据)",
    "482": "共 {} 条",
    "483": "我的联系人",
    "484": "客户管理",
    "485": "联系人管理",
    "486": "联系人信息查阅授权",
    "487": "通讯录操作记录",
    "488": "正在粘贴...",
    "489": "摘要",
    "490": "外链",
    "491": "不限大小",
    "492": "10M以内",
    "493": "大于100M",
    "494": "自定义",
    "495": "第一步：点击「新建任务」",
    "496": "在这里可以开始新建任务并进行网查任务相关的配置信息",
    "497": "第二步：输入任务基本信息",
    "498": "在这里你可以输入需要进行的网查任务名称，并将该任务与项目进行关联",
    "499": "第三步：下载并导入网查清单",
    "500": "1、将下载模板后，按照对应格式填写相关信息，再将完善好的表格进行上传",
    "501": "2、选择各个分类下所需要查询的省市级网站及海关信息，完成配置后点击「确定并继续」",
    "502": "第四步：配置查询网站",
    "503": "在这里你可以选择不同分类下需要查询的网站，或添加其他网站，完成后点击「确认并继续」",
    "504": "第五步：启动网查任务",
    "505": "任务配置完成后，在当前页面可查看本次任务的查询数量及权益信息，点击「立即启动」后网查任务自动开始",
    "506": "第六步：查看任务详情",
    "507": "在这里你可以查看当前网查任务下查询的子任务的更新状态",
    "508": "第七步：查看完成查询的任务文件",
    "509": "在点击「查看文件」跳转至网查任务所在的项目文件夹",
    "510": "第八步：查看项目文件",
    "511": "已完成查询的任务文件会自动存储在当前项目>智能网查文件夹内。",
    "512": "现在，你已经完成了智能网查工具的核心功能流程使用，现在去创建自己的网查任务吧",
    "513": "转发",
    "514": "新建",
    "515": "任务文件夹",
    "516": "在线模板",
    "517": "目录模板",
    "518": "底稿变动记录",
    "519": "上传",
    "520": "设置上传路径",
    "521": "批量关联底稿",
    "522": "文件内容",
    "523": "请输入文件内容关键字 以空格区分",
    "524": "修改时间",
    "525": "今日",
    "526": "近一周内",
    "527": "近一个月内",
    "528": "近三个月内",
    "529": "近六个月内",
    "530": "近一年内",
    "531": "非",
    "532": "在线编辑",
    "533": "在线预览",
    "534": "XB导出清洁版",
    "535": "内容关键字",
    "536": "多人在线编辑",
    "537": "任务中暂不支持单人本地编辑，请切换到多人在线编辑，或定位至源文件位置操作",
    "538": "目标文件已被锁定，暂不支持编辑，鼠标移入锁图标查看详情。如需继续操作请联系相关人员解锁或下载该文件",
    "539": "请选择至少一条数据",
    "540": "请选择一条数据",
    "541": "文件夹不能预览，请选择文件",
    "542": "审批中的文件不能重命名，请重新选择。",
    "543": "归档文件不可重命名",
    "544": "该文件不允许重命名",
    "545": "文件正在进行在线编辑不能进行此操作",
    "546": "不能包含特殊字符/:*?\"<>|",
    "547": "已有相同名称的{}，是否以 {} 命名{}",
    "548": "目录",
    "549": "重名提示",
    "550": "文件已锁定，不允许上传新版本",
    "551": "归档文件不可上传新版本",
    "552": "文件夹不支持该功能，请选择文件",
    "553": "荣大XB文件不支持查看版本",
    "554": "权限校验失败,请联系管理员",
    "555": "当前项目已终止,不可以进行此操作",
    "556": "文件已经被系统锁定,不允许执行此操作",
    "557": "文件已经归档,不允许执行此操作",
    "558": "当前数据不完整,请联系管理员",
    "559": "智慧投行管理系统",
    "560": "修改密码",
    "561": "切换后台",
    "562": "一键同步",
    "563": "退出登录",
    "564": "个人信息",
    "565": "欢迎您",
    "566": "项目编码",
    "567": "项目状态",
    "568": "操作",
    "569": "上传新文件",
    "570": "初始化",
    "571": "未上传",
    "572": "上传成功",
    "573": "上传失败",
    "574": "初始化完成，等待上传",
    "575": "不同意",
    "576": "不通过",
    "577": "驳回",
    "578": "请输入项目名称",
    "579": "未设置执行人",
    "580": "未设置抄送人",
    "581": "任务时间",
    "582": "当前为内测环境，即将跳转到正式环境，若仍需要使用内测环境，请联系 {} 进行咨询",
    "583": "当前为正式环境，即将跳转到内测环境，若仍需要使用正式环境，请联系 {} 进行咨询",
    "584": "投行机构",
    "585": "创建一个组织/项目",
    "586": "建立一个IPO项目并添加团队成员",
    "587": "欢迎来到智慧云，创建一个组织/项目是开启投行工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "588": "日常沟通协作",
    "589": "围绕项目文件协作展开的高效沟通",
    "590": "无论是券商收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在消息中讨论的所有过程文件都会被留痕，让工作有源可溯、有迹可循",
    "591": "项目文件管理",
    "592": "收集发行人资料、整理底稿、撰写招股说明书",
    "593": "智慧云预置了最新的项目底稿文件模板，可以在线一键导入，并按照底稿目录的要求实时收集发行人的底稿材料。同时可以对常见文件类型进行在线多人编辑或单人本地编辑，提高文件整理效率",
    "594": "任务分配",
    "595": "通过任务分配把控项目整体进度",
    "596": "创建或导入项目进行中各阶段的任务，方便对项目过程中的事项集中管理，有序规划工作节奏，及时了解项目任务的执行进展，尽早规避潜在风险。成员可以将任务分享至其他成员，与团队成员协作完成任务，共同达成团队目标",
    "597": "实习生管理",
    "598": "对项目角色进行权限分配，将敏感数据有效隔离",
    "599": "在项目承做过程中需要进行数据隔离或不希望部分角色接触到核心数据时，可以在智慧云中通过任务分发的方式进行数据隔离并完成项目任务，或对项目角色进行可操作/查看内容范围的权限配置，对于即将退出或已经退出项目的成员可以做到数据的有效隔离",
    "600": "质控内核",
    "601": "区分过程文件目录与底稿目录，支持文件外批注，支持导出批注",
    "602": "在项目的质控与内核过程中，你可以在智慧云内通过将项目文档按团队或分工的形式建立不同的文件目录开展相对应的工作，通过底稿视图索引项目文件生成底稿目录快速有效的区分过程文件与底稿文件，同时支持对文件进行批注与导出。",
    "603": "专业的应用程序",
    "604": "穿行测试PDF文件解析、智能网查、走访盘点相机、XBRL等应用程序",
    "605": "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决在项目全流程上的多种业务场景问题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心",
    "606": "私募基金",
    "607": "建立一个属于自己公司机构类型的组织并添加团队成员",
    "608": "欢迎来到智慧云，创建一个组织/项目是开启基金管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "609": "全生命周期管理",
    "610": "任务清单式的全生命周期项目管理",
    "611": "你可以通过智慧云实现私募基金的全生命周期管理，通过任务式清单建立开放高效的协作体系，在任务看板中即可随时掌握所有产品进度，再多产品并行也能及时把控，任务完成后产出的文件会自动归集为项目文件，过程资料将自动归档，无需事后补充或二次核查，让项目管理更高效",
    "612": "围绕基金产品的项目任务展开内外部高效沟通协作",
    "613": "多部门协作的产品要素表制作或合同要素信息、估值表、投资者信息的分享，都可以通过智慧云在线讨论功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循。亦或基金合同状态查询，也可通过项目伴生群时时接收最新合同动态",
    "614": "基金合同状态查询",
    "615": "一站式查询所有基金产品合同状态及信息",
    "616": "基金合同或其他文件可以通过项目的形式进行管理，项目创建完成会自动生成对应的项目伴生群，在项目伴生群内有关基金合同的所有信息可以随时随地在手机端或电脑端进行查看实时信息或历史信息",
    "617": "发行人(上市/拟上市公司)",
    "618": "创建一个IPO项目",
    "619": "建立一个企业IPO项目并添加团队成员",
    "620": "欢迎来到智慧云，建立一个组织/项目是开启IPO工作的必要前提，作为组织/项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在组织/项目的全部权限，可以对不同角色的成员进行权限的配置",
    "621": "无论是券商机构收集发行人的申报材料，或发行人准备上市材料等与文件协作相关的场景，都可以通过智慧云的「发送到聊天」功能对项目文件进行针对性的沟通，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循",
    "622": "文件高效传递/协作",
    "623": "避免反复向多方提供文件，文件变更后自动同步，无需二次传递",
    "624": "发行人上市过程中忙于经营，在券商机构承做上市申报材料时，为避免包含同一数据或需要反复引用的文件在多方传递或被修改后由于更新版本不一致而影响申报材料制作，可以将所有项目文件在智慧云内进行统一管理，当原始文件数据更新后，所有相关文件将同步更新，避免因文件材料无效而影响整体上市进度",
    "625": "分配任务进行资料收集管理",
    "626": "董秘办分配任务到各部门，附带文件模板，自动归集产出文件",
    "627": "在企业上市前夕需要相关负责人来协调统筹上市工作所需要的所有材料文件，智慧云预置了上市过程中各阶段的任务模板，负责人可以通过任务分享的方式在企业内部快速收集所需的文件材料，分配给执行人的任务可以附带文件模板说明及注意事项，更精确有效的归集文件，任务完成后产出的文件会自动归集为项目文件，省去二次整理的时间，让任务管理更高效",
    "628": "项目文件操作留痕",
    "629": "记录与文件相关的操作，并生成统计简报定期推送",
    "630": "为更好的管理上市前夕内部的材料准备，部门协作人对上级分发的任务完成情况，或项目内文件的操作动态可以通过每日简报获取相关的操作数据，文件留痕使过程容易被追溯",
    "631": "专业应用",
    "632": "董监高辅导验收模拟考试（IPO版驾考宝典）",
    "633": "智慧云「应用中心」是一个精心打造的集成了各种类型与项目相关的应用集合工作台，在这里你可以通过丰富独立的应用程序来解决项目上市过程中的多种业务场景题，快速整合申报信息从而提高团队工作效率，让成员更省心，管理者更放心",
    "634": "企业内部管理",
    "635": "按事物或部门创建项目",
    "636": "创建一个契合你部门或事物的项目并添加团队成员",
    "637": "欢迎来到智慧云，建立一个项目是开启企业内部管理工作的必要前提，作为项目创建者，你可以将其他成员添加至项目组内进行协同工作，同时你拥有所在项目的全部权限，可以对不同角色的项目成员进行权限配置",
    "638": "新成员可查看历史消息，提高工作交接效率",
    "639": "智慧云提供了针对项目文件进行的实时讨论功能，在项目伴生群中讨论的所有过程文件都会被留痕，让文件有源可溯、有迹可循，为所有参与项目的成员了解历史信息提供了便捷的帮助",
    "640": "基于项目管理文件，持续积累沉淀形成企业内部知识库",
    "641": "智慧云提供了基于项目文件的模板配置功能，你可以通过配置生成统一的文件模板，协作成员可以对文件进行在线同步编辑或单人本地编辑，在不断的积累沉淀过程中形成企业内部的知识库",
    "642": "通过任务分配把控项目整体进度，共同达成团队目标",
    "643": "创建或导入需要工作协同的任务，将任务分享至相关的执行人进行协同，分配给执行人的任务可以附带相关文件说明及注意事项，更精确有效的传达任务目标，任务完成后产出的文件会自动归集为项目文件，在把控团队执行进度的同时，使工作目标可以更有效完成规划",
    "644": "集团客户管理",
    "645": "建立项目层级，管理层级关系复杂的集团客户",
    "646": "对层级关系复杂的企业，可以通过真实的组织架构进行项目分层级管理，使项目预览更加高效，同时对常参与的项目可以进行收藏管理，方便用户一键触达对应项目内",
    "647": "企业管理权限设置",
    "648": "无需参与项目，按部门或按业务类型查阅所有项目",
    "649": "企业管理员可以通过后台管理对组织内不同成员角色进行可访问数据和可操作功能的权限配置，可以有效的对不同成员进行数据隔离，防止潜在风险发生",
    "650": "包含证券公司、律所、会所等机构对投行项目的日常管理操作",
    "651": "基金产品全生命周期管理",
    "652": "项目申报中的文件传递、日常沟通、分配任务等，所有工作都聚合一处",
    "653": "团队及日常工作事物一站式管理",
    "654": "项目设置",
    "655": "项目名备注",
    "656": "添加至收藏",
    "657": "取消收藏",
    "658": "添加至「收藏」",
    "659": "失败",
    "660": "文件名",
    "661": "编辑模式",
    "662": "修改人",
    "663": "大小",
    "664": "文件路径",
    "665": "新建子文件夹",
    "666": "上传新版本成功！",
    "667": "时间从近到远",
    "668": "时间从远到近",
    "669": "文件从大到小",
    "670": "文件从小到大",
    "671": "多文件",
    "672": "编辑打开",
    "673": "文件格式错误，无法另存！",
    "674": "您已不在该组织，请选择其它保存位置",
    "675": "您已不在该项目，请选择其它保存位置",
    "676": "审批流程",
    "677": "请输入审批流程名称,多个请用空格隔开",
    "678": "申请内容",
    "679": "请输入申请内容,多个请用空格隔开",
    "680": "交接人员",
    "681": "审核中",
    "682": "底稿",
    "683": "审批",
    "684": "参考文件",
    "685": "调查工具",
    "686": "自然日",
    "687": "一",
    "688": "二",
    "689": "三",
    "690": "四",
    "691": "五",
    "692": "六",
    "693": "日",
    "694": "截止前15分钟",
    "695": "截止前1小时",
    "696": "截止前3小时",
    "697": "截止前1天",
    "698": "开始前一天",
    "699": "开始时",
    "700": "完成时",
    "701": "应用内消息",
    "702": "Excel文档",
    "703": "PPT文档",
    "704": "Txt文档",
    "705": "确认要把文件放入回收站吗?删除的文件可随时通过回收站还原。",
    "706": "已取消删除",
    "707": "删除成功！",
    "708": "当前页不可重命名",
    "709": "只能重命名一个",
    "710": "请选择想要剪切的文件或文件夹",
    "711": "剪切成功!",
    "712": "复制成功!",
    "713": "当前页不可粘贴",
    "714": "请先复制或剪切",
    "715": "粘贴内容超出网盘容量",
    "716": "可用空间已满",
    "717": "新建{}文档",
    "718": "新建失败",
    "719": "只能对一个文件上传新版本",
    "720": "文件夹不支持上传新版本，请选择文件",
    "721": "解锁文件夹下所有的文件",
    "722": "文件已另存到",
    "723": "去查看",
    "724": "另存失败，请重新操作",
    "725": "文件上传失败",
    "726": "因当前空间不足，导致文件上传失败",
    "727": "因当前空间不足，导致文件上传失败 ；请联系",
    "728": "进行空间查询与管理",
    "729": "空间查询",
    "730": "升级扩容",
    "731": "因当前空间不足，导致文件上传失败；请进行空间查询与管理!",
    "732": "当前只可选择文件",
    "733": "文件较大，正在另存中...",
    "734": "个人网盘空间不足",
    "735": "未选中文件",
    "736": "未选中文件夹",
    "737": "当前目录不可选择,请重新选择目录",
    "738": "讨论文件合集({}项)",
    "739": "等{}个文件,",
    "740": "评论了您的日志",
    "741": "在日志中@了您",
    "742": "回复了您的日志",
    "743": "加载中...",
    "744": "你可以将文件直接拖拽到这里，或者点击",
    "745": "审批催办",
    "746": "查看详情",
    "747": "接收范围",
    "748": "开始时间",
    "749": "结束时间",
    "750": "地址",
    "751": "至",
    "752": "等",
    "753": "限时免费",
    "754": "限时特惠",
    "755": "文件/文件夹数据过多、不支持上传、建议分批多次上传",
    "756": "暂无可查看任务",
    "757": "请前往项目任务查看任务，可同时打开10个任务",
    "758": "查看项目任务",
    "759": "还原",
    "760": "放大",
    "761": "关闭",
    "762": "播放",
    "763": "公告的图片",
    "764": "查看全文",
    "765": "查看",
    "766": "当前文件版本已发生变更，请选择你要操作的文件版本",
    "767": "历史版本",
    "768": "当前版本",
    "769": "[文件]",
    "770": "[文件夹]",
    "771": "打开文件夹",
    "772": "月",
    "773": "最近修改",
    "774": "下载最新文档",
    "775": "讨论文件合集({})项",
    "776": "消息已被撤回",
    "777": "来源于",
    "778": "语音",
    "779": "@所有人",
    "780": "选择执行人",
    "781": "来自",
    "782": "选择开始时间",
    "783": "选择结束时间",
    "784": "任务标签",
    "785": "查看更多",
    "786": "设为前置",
    "787": "取消前置",
    "788": "详情",
    "789": "重新编辑",
    "790": "任务已被删除",
    "791": "点击查看",
    "792": "你",
    "793": "分享了一篇日志",
    "794": "查看全部",
    "795": "评论",
    "796": "】来源于:",
    "797": "讨论",
    "798": "相关任务",
    "799": "文件权限",
    "800": "Txt文本",
    "801": "请切换到主窗口操作此功能",
    "802": "该审批已撤销",
    "803": "您已不在当前审批中，无法查看",
    "804": "关闭和跳转将不会保存你已编辑的群公告内容?",
    "805": "上传失败,仅文件列表区域支持拖拽上传",
    "806": "退出成功!",
    "807": "根目录",
    "808": "XB功能暂不支持使用",
    "809": "您好，您的XBRL已到期。请注意数据中心词条数据将不会同步至XB文档，请及时联系对应商务续费谢谢！",
    "810": "后续不再提示",
    "811": "正在加载...",
    "812": "本科",
    "813": "后退",
    "814": "前进",
    "815": "返回上一级",
    "816": "创建文件夹",
    "817": "联系人/群组",
    "818": "聊天记录",
    "819": "聊天记录中的文件",
    "820": "视频",
    "821": "音频",
    "822": "{}正在播放—荣大智慧云",
    "823": "页面访问权限",
    "824": "查看权限",
    "825": "新建权限",
    "826": "编辑权限",
    "827": "下载与分享权限",
    "828": "文档管理权限",
    "829": "客户权限",
    "830": "联系人权限",
    "831": "通讯录管理权限",
    "832": "项目信息查看",
    "833": "有权访问查看项目信息页面",
    "834": "标签信息编辑",
    "835": "有权编辑项目信息中的标签值",
    "836": "项目信息编辑",
    "837": "有权编辑项目信息内容",
    "838": "中介机构关联",
    "839": "有权增加/移除项目中介机构，并关联机构下相关联系人",
    "840": "联系人查看",
    "841": "有权查看已关联到项目的联系人信息，同时需要拥有组织角色中联系人的查看权限",
    "842": "项目成员管理",
    "843": "有权访问项目【成员管理】页面",
    "844": "成员邀请",
    "845": "有权邀请人员加入当前项目",
    "846": "成员移除",
    "847": "有权移除项目成员",
    "848": "成员加入审核",
    "849": "有权通过/拒绝人员提出加入项目的申请",
    "850": "成员角色设置",
    "851": "有权修改或赋予成员的项目角色，调整成员在项目内的操作权限",
    "852": "项目角色管理",
    "853": "有权访问项目【角色权限】页面",
    "854": "角色权限编辑",
    "855": "有权修改/配置项目角色在项目中的可操作功能",
    "856": "项目角色创建",
    "857": "有权创建新的项目角色",
    "858": "项目角色重命名",
    "859": "有权修改项目角色名称",
    "860": "项目角色删除",
    "861": "有权删除项目角色",
    "862": "项目任务访问",
    "863": "有权访问项目任务页面，查看项目中的任务列表",
    "864": "任务/子任务创建",
    "865": "有权在任务列表中创建新任务，在任务中创建子任务，在文档中创建任务文件夹",
    "866": "全部任务访问",
    "867": "有权查看项目内所有任务信息，无论是否作为任务执行人或被抄送",
    "868": "全部任务编辑",
    "869": "有权编辑项目内所有任务信息，无论是否作为任务执行人或被抄送",
    "870": "全部任务关闭",
    "871": "有权关闭项目内所有任务数据，无论是否作为任务执行人",
    "872": "全部任务删除",
    "873": "有权删除项目内所有任务数据，无论是否作为任务执行人",
    "874": "任务标签管理",
    "875": "有权新增或修改项目内的任务标签",
    "876": "任务工时管理",
    "877": "有权在任务中，设置更新他人任务工时",
    "878": "项目日志访问",
    "879": "有权访问项目日志列表，查看项目内日志数据",
    "880": "项目日志创建",
    "881": "有权在项目中创建新日志，或在【我的日志】中创建所属此项目的日志",
    "882": "项目日志导出",
    "883": "有权将项目日志数据内容导出下载到本地或保存到项目文档",
    "884": "项目日志总览",
    "885": "有权查看项目内所有日志数据，无论是否被抄送",
    "886": "项目会议访问",
    "887": "有权访问查看项目会议列表",
    "888": "项目会议创建",
    "889": "有权在此项目中创建新会议",
    "890": "项目会议编辑",
    "891": "有权在此项目中编辑会议内容",
    "892": "项目会议删除",
    "893": "有权在此项目中删除会议数据",
    "894": "项目会议导出",
    "895": "有权在此项目中导出会议列表",
    "896": "项目投票访问",
    "897": "有权访问查看项目投票列表",
    "898": "项目投票创建",
    "899": "有权在此项目中创建新的投票",
    "900": "项目投票编辑",
    "901": "有权在此项目中编辑投票内容",
    "902": "项目投票删除",
    "903": "有权在此项目中删除投票记录",
    "904": "项目投票导出",
    "905": "有权在此项目中导出投票列表",
    "906": "项目文档访问",
    "907": "有权访问项目中项目文档页面，文件操作权限以配置为准",
    "908": "底稿视图访问",
    "909": "有权访问项目中底稿视图页面，文件操作权限以配置为准",
    "910": "回收站访问",
    "911": "文件预览",
    "912": "在项目文档与底稿视图中，有权预览打开文件",
    "913": "历史版本预览",
    "914": "在项目文档与底稿视图中，有权预览打开文件的历史版本",
    "915": "文件只读",
    "916": "在项目文档与底稿视图中，有权只读打开文件",
    "917": "历史版本只读",
    "918": "在项目文档与底稿视图中，有权只读打开文件的历史版本",
    "919": "文档创建",
    "920": "有权在当前项目文档与底稿视图中新建文件/文件夹/文件目录",
    "921": "文档上传",
    "922": "有权从本地上传文件/文件夹至项目文档或底稿视图",
    "923": "文档粘贴",
    "924": "有权从别的项目/组织中粘贴文件至当前项目文档或底稿视图",
    "925": "本地/在线编辑",
    "926": "有权在项目文档与底稿视图中进行本地/在线编辑文件",
    "927": "文档重命名",
    "928": "有权在项目文档与底稿视图中修改文件/文件夹名称",
    "929": "新版本上传",
    "930": "有权在项目文档与底稿视图中通过本地上传更新文件版本",
    "931": "历史版本还原",
    "932": "有权在项目文档与底稿视图中使用文件历史版本替代当前版本",
    "933": "文档删除",
    "934": "有权在项目文档与底稿视图中进行文件/文件夹删除",
    "935": "文档剪切",
    "936": "有权在项目文档与底稿视图中对文件/文件夹进行剪切操作",
    "937": "有权在底稿视图中通过引用目录模板，替换当前底稿目录",
    "938": "编辑底稿索引",
    "939": "有权在底稿视图中编辑或批量编辑底稿索引",
    "940": "文档下载",
    "941": "有权在项目文档与底稿视图中下载文件/文件夹",
    "942": "历史版本下载",
    "943": "有权在项目文档与底稿视图中下载文件的历史版本",
    "944": "有权在项目文档与底稿视图中将文件/文件夹发送到会话聊天",
    "945": "有权在项目文档与底稿视图中将文件/文件夹通过外链的方式进行分享",
    "946": "文档复制",
    "947": "有权在项目文档与底稿视图中将文件或文件夹进行复制后粘贴至其它项目",
    "948": "有权在项目文档与底稿视图中将文件或文件夹保存副本到个人网盘",
    "949": "文件解锁(管理员)",
    "950": "有权在文档中解锁他人手动上锁文件以及因为网络等原因完成编辑后未能正常解除的文件锁定",
    "951": "文档设置",
    "952": "有权访问文档设置页面，根据文件格式管理文档中，在线编辑功能的使用",
    "953": "有权在文档中发起文件审批",
    "954": "新建项目",
    "955": "有权在组织下新建项目",
    "956": "项目导出",
    "957": "有权在组织下项目列表中进行列表信息导出",
    "958": "项目标签管理",
    "959": "有权新增/编辑删除项目标签数据",
    "960": "项目标签引用",
    "961": "有权在项目中关联项目标签",
    "962": "项目编码修改",
    "963": "有权在组织内项目的项目信息页面，修改项目编码，需要同时拥有项目内编辑信息权限",
    "964": "重复项目筛查",
    "965": "有权在项目列表使用重复项目筛查功能",
    "966": "提交审批",
    "967": "有权在组织下的项目里提交各类审批",
    "968": "项目回收站管理",
    "969": "有权访问项目回收站",
    "970": "项目还原",
    "971": "有权在项目回收站还原已删除的项目",
    "972": "项目终止库管理",
    "973": "有权访问项目终止库",
    "974": "借阅记录",
    "975": "有权在项目归档库中，查看归档项目的借阅记录",
    "976": "查看所有归档项目",
    "977": "有权不经过审批，在项目归档库中直接查看已归档项目",
    "978": "有权查看组织内所有项目的空间占用情况，可以对组织里所有项目的文档回收站进行清空操作",
    "979": "日程抄送人设置",
    "980": "有权在工作台的日历表中，设置日程抄送人",
    "981": "有权在工作台查看组织内的项目统计信息",
    "982": "组织管理",
    "983": "组织管理的相关权限",
    "984": "工作台的相关权限",
    "985": "后台管理",
    "986": "项目信息的相关权限",
    "987": "项目成员的相关权限",
    "988": "项目任务的相关权限",
    "989": "项目日志的相关权限",
    "990": "项目会议的相关权限",
    "991": "项目投票的相关权限",
    "992": "请输入内容",
    "993": "段落",
    "994": "标题1",
    "995": "标题2",
    "996": "标题3",
    "997": "标题4",
    "998": "标题5",
    "999": "标题6",
    "1000": "请输入",
    "1001": "请输入任务内容",
    "1002": "请输入注意事项",
    "1003": "s 后自动关闭",
    "1004": "感谢你的反馈！",
    "1005": "你的观点对我们有着至关重要的帮助，你的反馈已被我们高度重视，同时会在接下来提升我们产品体验的过程中被使用",
    "1006": "一般般",
    "1007": "联系人",
    "1008": "普通群",
    "1009": "项目群",
    "1010": "会话",
    "1011": "单聊",
    "1012": "群聊",
    "1013": "左侧边栏导航",
    "1014": "功能栏",
    "1015": "表格列表",
    "1016": "单选右键",
    "1017": "多选右键",
    "1018": "空白区域右键",
    "1019": "列表悬浮按钮",
    "1020": "文件路径导航栏",
    "1021": "文件夹空白页按钮",
    "1022": "项目列表右键操作",
    "1023": "目录树",
    "1024": "另存为弹框",
    "1025": "组织空间",
    "1026": "回收站详情",
    "1027": "输入关键词开始搜索",
    "1028": "暂无内容",
    "1029": "您暂无权限访问，请联系系统管理员进行处理",
    "1030": "当前项目已开启独立窗口",
    "1031": "暂无项目",
    "1032": "新建你的「项目」开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "1033": "多选",
    "1034": "第一个节点下的全选",
    "1035": "其他节点下的全选",
    "1036": "没有用户id",
    "1037": "没有ip权限",
    "1038": "组织列表为空",
    "1039": "项目id记录为空",
    "1040": "请选择日期",
    "1041": "请输入数字",
    "1042": "在线",
    "1043": "忙碌",
    "1044": "离线",
    "1045": "重连恢复在线状态失败, 请刷新重试",
    "1046": "状态修改失败，{}",
    "1047": "[图片]",
    "1048": "文件齐备性校验",
    "1049": "使用Excel文件中的文件名称列，大批量检测目录下是否存在指定文件，检测结果将生成一个单独的控制表。检测完成后，将推送系统消息，检验文件数较多时可能需要等待一定时间",
    "1050": "批量文件快速查找、批量文件重新归档",
    "1051": "使用Excel文件中的文件名称列，以复制文件的方式，大批量提取目录下指定文件到另一个目录，提取结果将保存在一个单独的文件夹当中，并生成控制表。提取完成后，将推送系统消息，提取文件数较多时可能需要等待一定时间",
    "1052": "目录一致性校验、空文件夹批量校验",
    "1053": "选中指定文件夹，导出其下所有文件夹与文件名称，包含格式、上级目录、是否空文件夹。导出完成后，将推送系统消息，导出文件数较多时可能需要等待一定时间",
    "1054": "选择待检验目录",
    "1055": "选择目录文件",
    "1056": "选择待提取目录",
    "1057": "选择保存位置",
    "1058": "选择待导出目录",
    "1059": "获取自定义字段查询错误！",
    "1060": "忙碌中，请您留言，稍后回复",
    "1061": "您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！",
    "1062": "【自动回复】忙碌中，请您留言，稍后回复。",
    "1063": "【自动回复】您可以留言，我们看到后会在第一时间进行回复，或者您可以联系其他的客服人员，我们将竭诚为您服务！",
    "1064": "获取at成员信息失败，{}",
    "1065": "您好！我是{}，您有什么问题可以直接发送给我，我们会在第一时间为您解答！",
    "1066": "仅支持发送文件大小20M以内的图片",
    "1067": "{}【讨论文件合集({}项)】{}",
    "1068": "{}[图片]",
    "1069": "{}[文件]{}",
    "1070": "{}[群公告]",
    "1071": "置顶",
    "1072": "取消置顶",
    "1073": "移除会话",
    "1074": "消息免打扰",
    "1075": "允许消息通知",
    "1076": "草稿",
    "1077": "【讨论文件合集({}项)】",
    "1078": "有人@我",
    "1079": "日志消息",
    "1080": "[该消息类型本版本暂不支持查看(如需了解消息内容，请直接联系发送人)]",
    "1081": "条消息",
    "1082": "个文件",
    "1083": "条群公告",
    "1084": "该会话不存在",
    "1085": "您已离开该群聊，请联系相关人员进行添加！",
    "1086": "{}撤回了一{}",
    "1087": "请输入日志标题",
    "1088": "请输入日志内容",
    "1089": "发出人",
    "1090": "提交时间",
    "1091": "请输入日志评论内容",
    "1092": "点击选择日志评论人",
    "1093": "点击选择日志接收人",
    "1094": "搜索关联客户",
    "1095": "这个功能没什么用",
    "1096": "它分散了注意力",
    "1097": "不易理解上手难",
    "1098": "无法解决我的使用需求",
    "1099": "普通粘贴",
    "1100": "返回",
    "1101": "清空回收站",
    "1102": "您所在组织[{}]智慧云空间不足，请清理项目文档回收站或联系组织管理员进行扩容",
    "1103": "刚刚",
    "1104": "分钟前",
    "1105": "MM月DD日 HH:mm",
    "1106": "YYYY年MM月DD日 HH:mm",
    "1107": "所有人",
    "1108": "清空",
    "1109": "发送文件到",
    "1110": "拖拽编辑",
    "1111": "拖拽文件到此处进行上传",
    "1112": "当前应用不可用，请联系管理员",
    "1113": "没有匹配的小程序信息",
    "1114": "回复",
    "1115": "加急",
    "1116": "打开文件",
    "1117": "撤回",
    "1118": "该合并文件已超过600MB，请前往PC端下载",
    "1119": "历史版本V{}",
    "1120": "当前版本V{}",
    "1121": "群公告图片",
    "1122": "[有人@你]",
    "1123": "[@所有人]",
    "1124": "{}条新消息",
    "1125": "999+条新消息",
    "1126": "已超过可撤回时效",
    "1127": "已保存任务",
    "1128": "是否发消息通知执行人和抄送人?",
    "1129": "通知",
    "1130": "不用通知",
    "1131": "通知成功",
    "1132": "无法删除他人添加的执行人，请联系任务创建者操作",
    "1133": "(重复号码)",
    "1134": "请填写手机号",
    "1135": "(格式错误)",
    "1136": "删除任务",
    "1137": "关闭任务",
    "1138": "已开启拖拽排序功能",
    "1139": "已关闭拖拽排序功能",
    "1140": "确定要删除任务{}？",
    "1141": "确定要关闭任务{}",
    "1142": "确定要打开任务{}",
    "1143": "人未读",
    "1144": "全部已读",
    "1145": "正在努力加载中，请稍候…",
    "1146": "正在解锁并上传新版本，请稍候…",
    "1147": "查看成员",
    "1148": "下级",
    "1149": "创建普通群",
    "1150": "添加成员",
    "1151": "邀请成员",
    "1152": "条",
    "1153": "数据安全预警",
    "1154": "请登录CRM查看预警详情",
    "1155": "触发次数",
    "1156": "查看人员清单",
    "1157": "项目简报统计",
    "1158": "统计范围:所有项目(含可访问数据源)、按天提醒、昨天数据",
    "1159": "文件：",
    "1160": "次数：",
    "1161": "文件夹：",
    "1162": "应用时间:",
    "1163": "转发消息",
    "1164": "发送文件",
    "1165": "添加附件",
    "1166": "本地上传",
    "1167": "项目文档选择",
    "1168": "底稿选择",
    "1169": "请先选择项目后再添加附件",
    "1170": "当前审批未关联项目，因此无法选择底稿和项目文档文件",
    "1171": "当前未关联项目，因此无法选择底稿和项目文档文件",
    "1172": "请先选择所属项目",
    "1173": "选择浏览器",
    "1174": "本地浏览器",
    "1175": "扩展功能现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge",
    "1176": "暂无可用浏览器",
    "1177": "现支持Chrome浏览器、火狐浏览器、360极速模式浏览器、Safari浏览器、QQ极速模式浏览器、Microsoft Edge",
    "1178": "Chrome浏览器",
    "1179": "火狐浏览器",
    "1180": "360极速模式浏览器",
    "1181": "QQ极速模式浏览器",
    "1182": "Safari浏览器",
    "1183": "开始日期",
    "1184": "结束日期",
    "1185": "版本号",
    "1186": "生成人",
    "1187": "点击查看在线编辑临时文件",
    "1188": "日期",
    "1189": "对 比",
    "1190": "文件版本",
    "1191": "还原后，当前文件「V{}」版本会保留在「文件版本」中同时会生成新的版本内容。确定要将文件还原为V{}版本内容吗？",
    "1192": "确定要还原版本内容吗？",
    "1193": "请选择两个版本进行对比",
    "1194": "文件已锁定，您不可以进行该操作",
    "1195": "还原成功",
    "1196": "归档文件不可进行此操作",
    "1197": "文件已锁定，不允许回退版本",
    "1198": "文件已锁定，不允许还原版本",
    "1199": "审批通过/审批中/修订审批中不允许还原版本",
    "1200": "回到应用中心",
    "1201": "中的搜索结果",
    "1202": "清空检索条件",
    "1203": "刷新",
    "1204": "更多目录",
    "1205": "已选中{}项",
    "1206": "请选择",
    "1207": "序号",
    "1208": "请选择项目",
    "1209": "搜索行业代码/行业分类名称",
    "1210": "搜索",
    "1211": "全选",
    "1212": "暂无数据",
    "1213": "重置",
    "1214": "重新加载",
    "1215": "正在加载中...",
    "1216": "数据获取失败，请重新加载！",
    "1217": "网络连接发生问题，请检查您的网络设置！",
    "1218": "多人在线编辑正在维护，暂不支持编辑模式切换，请双击文件使用单人本地编辑文件",
    "1219": "多人在线编辑正在维护，暂不支持编辑模式切换，请下载文件后在本地编辑文件",
    "1220": "图标",
    "1221": "多个文件",
    "1222": "多个文件夹",
    "1223": "多个",
    "1224": "个",
    "1225": "文件属性",
    "1226": "文件夹属性",
    "1227": "名称",
    "1228": "创建者",
    "1229": "包含",
    "1230": "正在计算...",
    "1231": "计算失败",
    "1232": "未选择行业分类，请先选择行业分类",
    "1233": "因多人在线编辑维护更新，编辑模式暂时不可切换，请使用单人本地编辑",
    "1234": "因多人在线编辑维护更新，编辑模式暂时不可切换，请下载文件使用本地office编辑完成后再上传文件",
    "1235": "网络异常，请检查当前设备的网络设置",
    "1236": "检测到当前账户",
    "1237": "未进行实名认证",
    "1238": "根据国家网络安全要求，账号需要“绑定手机号”实名认证后才能继续使用智慧云。可点击「实名认证」进行绑定。",
    "1239": "给您带来的不便，敬请谅解。",
    "1240": "实名认证",
    "1241": "我已认证",
    "1242": "切换组织",
    "1243": "请选择您想切换的组织",
    "1244": "加入新组织",
    "1245": "如果你的组织已在使用荣大智慧云，可通过组织ID查找加入，与成员一起沟通协作。",
    "1246": "创建新组织",
    "1247": "新组织创建后，你将成为管理员，可添加成员、管理组织架构，全面使用荣大智慧云的团队协作功能。",
    "1248": "加入或创建组织",
    "1249": "找到属于你的组织，和成员们一起协作办公",
    "1250": "安全校验未通过",
    "1251": "您好,由于您进入的{}",
    "1252": "设置了安全验证,您的IP地址未在组织要求的范围内,请尝试联系组织管理员处理或更换对应符合要求的网络后重试",
    "1253": "搜索组织名称",
    "1254": "组织不存在,无法进行操作",
    "1255": "项目编码：",
    "1256": "请选择项目编码",
    "1257": "发起人所属部门",
    "1258": "选择日期",
    "1259": "上传附件",
    "1260": "审批环节",
    "1261": "请填完必填项，会默认展示审批流程图。",
    "1262": "发起人",
    "1263": "审批人",
    "1264": "审批方式:",
    "1265": "注：审批流程涉及项目角色，需要选择项目后显示审批人。",
    "1266": "抄送方式:审批通过后通知",
    "1267": "添加抄送人",
    "1268": "注：审批流程涉及项目角色，需要选择项目后显示抄送人。",
    "1269": "是否设置提醒",
    "1270": "审批提醒",
    "1271": "接收人员",
    "1272": "提醒内容",
    "1273": "文件借阅",
    "1274": "借阅方式",
    "1275": "电子借阅",
    "1276": "纸质借阅",
    "1277": "借阅时间",
    "1278": "请选择借阅时间",
    "1279": "小时",
    "1280": "最多输入200字",
    "1281": "请选择部门",
    "1282": "审批方式",
    "1283": "抄送方式：审批通过后通知",
    "1284": "提 交",
    "1285": "底稿归档",
    "1286": "归档阶段",
    "1287": "审批环节:",
    "1288": "请输入申请内容，最多输入{}字",
    "1289": "提交",
    "1290": "IPO审核",
    "1291": "债务审核",
    "1292": "新三板审核",
    "1293": "归档表单",
    "1294": "你已经借阅当前文件",
    "1295": "底稿已被借阅",
    "1296": "请选择发起人所属部门",
    "1297": "项目归档成功后不可恢复，请谨慎操作是否确认提交归档申请？",
    "1298": "请选择您要借阅的时间",
    "1299": "请选择您要借阅的文件",
    "1300": "从借阅成功起，借阅时限为{}\"{}\"{}小时超过借阅时限后，借阅文件{}自动失效，无法查看{}是否确定借阅？",
    "1301": "确认关闭？",
    "1302": "本页面不可发起新建项目审批！",
    "1303": "无查看项目文档的权限",
    "1304": "项目所属业务类型与流程图所属业务类型不匹配",
    "1305": "提醒您尽快审批{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1306": "提醒您尽快审批关于{}项目的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1307": "{}项目的",
    "1308": "提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "1309": "接收人不能为空",
    "1310": "请填写提醒模版",
    "1311": "{}的邮箱发送失败；",
    "1312": "{}的短信发送失败；",
    "1313": "请在个人信息中完善！其余均发送成功",
    "1314": "请把表单填写完整",
    "1315": "有文件正在上传，请稍后操作",
    "1316": "请添加待审文件",
    "1317": "是否载入上次保存的草稿?",
    "1318": "确定要撤销申请吗, 是否继续?",
    "1319": "申请成功!",
    "1320": "已取消申请",
    "1321": "语言设置",
    "1322": "导航设置",
    "1323": "点击「右键」可以打开独立窗口",
    "1324": "点击进行自定义导航设置",
    "1325": "支持左右拖拽",
    "1326": "收起",
    "1327": "展开",
    "1328": "帮助",
    "1329": "隐藏应用名称",
    "1330": "已设为首页打开",
    "1331": "操作成功",
    "1332": "当前组织未填写股票代码，请前往组织信息中填写",
    "1333": "导航栏设置",
    "1334": "可以对导航栏入口进行排序和隐藏/显示设置",
    "1335": "取消首页打开",
    "1336": "创建一个组织",
    "1337": "在使用智慧云全部功能前，请先创建一个组织",
    "1338": "新组织",
    "1339": "创建",
    "1340": "新组织创建后，你将成员管理员，可添加成员、管理组织架构， 全面使用荣大智慧云的团队协作功能。",
    "1341": "加入项目",
    "1342": "当前",
    "1343": "收藏",
    "1344": "搜索项目",
    "1345": "编辑头像",
    "1346": "图片预览",
    "1347": "保存",
    "1348": "截图请大于",
    "1349": "编辑群信息",
    "1350": "群名称",
    "1351": "请输入群名称（字数限制{}字）",
    "1352": "群头像",
    "1353": "还原默认头像",
    "1354": "输入头像文字",
    "1355": "选择头像底色",
    "1356": "如果仅选择颜色，将使用该颜色的默认头像",
    "1357": "人员管理",
    "1358": "角色权限",
    "1359": "组织架构",
    "1360": "底稿管理",
    "1361": "目录管理",
    "1362": "流程引擎管理",
    "1363": "流程引擎",
    "1364": "系统配置",
    "1365": "业务类型配置",
    "1366": "任务配置",
    "1367": "业务规则配置",
    "1368": "借阅时间配置",
    "1369": "时间变量配置",
    "1370": "表单字段管理",
    "1371": "审批类型配置",
    "1372": "日志模板配置",
    "1373": "项目角色配置",
    "1374": "安全规则配置",
    "1375": "系统日志",
    "1376": "选择",
    "1377": "查询",
    "1378": "发起",
    "1379": "该流程不可用！",
    "1380": "不可发起新建项目审批！",
    "1381": "请选择项目！",
    "1382": "发起审批",
    "1383": "搜索业务类型",
    "1384": "共{}个结果,第{}个",
    "1385": "当前业务类型",
    "1386": "未搜索到结果",
    "1387": "无数据，请输入其他关键字后重试",
    "1388": "请输入想要搜索的业务类型关键字后点击搜索",
    "1389": "新增联系人",
    "1390": "姓名",
    "1391": "联系方式",
    "1392": "所属公司",
    "1393": "下一步",
    "1394": "请选择所属公司",
    "1395": "暂不支持输入特殊字符，请重新输入",
    "1396": "性别",
    "1397": "学历",
    "1398": "邮箱",
    "1399": "添加部门/职务",
    "1400": "是否公开",
    "1401": "非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目",
    "1402": "是",
    "1403": "否",
    "1404": "上一步",
    "1405": "男",
    "1406": "女",
    "1407": "新增成功",
    "1408": "在「{}」下新增联系方式",
    "1409": "确定要继续添加联系方式吗？",
    "1410": "联系方式为「{}」的联系人已存在",
    "1411": "联系方式为「{}」的联系人已存在，其信息未公开，无法查看，请联系通讯录管理员",
    "1412": "创建联系人",
    "1413": "将在企业【{}】下新增联系人【{}】，是否将此联系人关联至当前项目【{}】？",
    "1414": "仅创建",
    "1415": "创建并关联至项目",
    "1416": "查询到企业「{}」下存在同名联系人，请确认其是否已存在但未维护对应联系方式",
    "1417": "如果确认要新增联系人，请点击【跳过并到下一步】继续创建",
    "1418": "在职",
    "1419": "已离职",
    "1420": "添加联系方式",
    "1421": "跳过并到下一步",
    "1422": "链接发送到我手机",
    "1423": "预警人员清单",
    "1424": "请输入人员名称",
    "1425": "选择审批类型",
    "1426": "选择类型",
    "1427": "输入关键字进行搜索",
    "1428": "已选择类型",
    "1429": "暂无选中项",
    "1430": "当前该业务类型不可选",
    "1431": "已选择",
    "1432": "关联",
    "1433": "索引列表",
    "1434": "文件索引",
    "1435": "选中文件",
    "1436": "索引路径",
    "1437": "操作人",
    "1438": "关联任务",
    "1439": "暂无对应权限",
    "1440": "请联系管理员",
    "1441": "确认引用",
    "1442": "引用后，当前目录将会清空！",
    "1443": "我已确认",
    "1444": "确认",
    "1445": "跳过",
    "1446": "选择任务模板",
    "1447": "该业务类型没有匹配的任务模板（请联系管理员为该业务类型配置任务模板）",
    "1448": "未选择任务模板，请选中对应模板后重试",
    "1449": "该业务类型没有匹配的目录",
    "1450": "（请联系管理员为该业务类型配置目录）",
    "1451": "未选择目录模板，请选中对应模板后重试",
    "1452": "确定要引用该底稿目录吗？",
    "1453": "引用后，当前目录将会被覆盖，确定要引用吗？",
    "1454": "加载失败",
    "1455": "请选择内容",
    "1456": "选择中介机构",
    "1457": "已选机构",
    "1458": "选择团队成员",
    "1459": "团队成员",
    "1460": "已选成员",
    "1461": "关联角色不能为空！",
    "1462": "选择业务类型",
    "1463": "跳 过",
    "1464": "当前项目阶段为空，不可选择",
    "1465": "清空选项",
    "1466": "请选择客户",
    "1467": "数据中心",
    "1468": "使用",
    "1469": "该类型暂不支持编辑",
    "1470": "表情",
    "1471": "自然",
    "1472": "物品",
    "1473": "地点",
    "1474": "符号",
    "1475": "当前支持核查文件的数量的最大值为{}个！",
    "1476": "单文件大小要小于等于{}M",
    "1477": "当前只支持对DOC、DOCX、XLS、XLSX、PDF（必须是可编辑版转换的）的文件进行核查！",
    "1478": "文件参数格式缺失！",
    "1479": "分享文件",
    "1480": "您可以将链接分享给您的朋友们",
    "1481": "复制链接",
    "1482": "取消外链",
    "1483": "复制成功",
    "1484": "复制失败",
    "1485": "外链取消成功",
    "1486": "外链取消失败",
    "1487": "文件分享",
    "1488": "移除",
    "1489": "重置链接",
    "1490": "通过二维码分享",
    "1491": "链接复制成功",
    "1492": "链接复制失败",
    "1493": "二维码复制成功",
    "1494": "二维码复制失败",
    "1495": "备注",
    "1496": "当前已选中",
    "1497": "新增备注",
    "1498": "请输入备注",
    "1499": "最多输入{}字",
    "1500": "请新增备注内容",
    "1501": "新增备注成功",
    "1502": "创建模板分类",
    "1503": "创 建",
    "1504": "上传到模板提示",
    "1505": "选择目录",
    "1506": "请选择目录",
    "1507": "编辑会议",
    "1508": "选择人员",
    "1509": "请输入会议主题",
    "1510": "请选择会议类型",
    "1511": "请输入会议地点",
    "1512": "起止时间",
    "1513": "会议时间",
    "1514": "会议开始时间",
    "1515": "会议结束时间",
    "1516": "提醒",
    "1517": "请输入会议内容",
    "1518": "会议开始时间不能为空",
    "1519": "会议结束时间不能为空",
    "1520": "开始时间不能小于当前时间",
    "1521": "不能同时为参会和列席人员",
    "1522": "会议主题不能为空",
    "1523": "会议地点不能为空",
    "1524": "开始时间不能大于结束时间",
    "1525": "开始时间不能等于结束时间",
    "1526": "请选择提醒方式",
    "1527": "暂无备注信息",
    "1528": "备注内容",
    "1529": "备注时间",
    "1530": "发送",
    "1531": "请输入备注内容",
    "1532": "文件关联",
    "1533": "所有人可见备注，对文件夹右键可导出核查报告（所有文件的备注）",
    "1534": "隐藏",
    "1535": "确认永久隐藏该功能吗？可在更多中勾选 \" 核查备注 \" 重新开启。",
    "1536": "确定删除备注吗？",
    "1537": "删除备注成功",
    "1538": "文件上传",
    "1539": "进度条",
    "1540": "上传速度",
    "1541": "添加文件",
    "1542": "开始上传",
    "1543": "最大允许上传{}条数据",
    "1544": "初始化中",
    "1545": "允许上传的文件类型为",
    "1546": "上传中",
    "1547": "删除成功",
    "1548": "保存新版本失败，请联系客服处理。",
    "1549": "客服电话",
    "1550": "我的客户-企业客户-客户文档",
    "1551": "我的客户-自然人客户-客户文档",
    "1552": "我的客户-中介机构-客户文档",
    "1553": "投票决策",
    "1554": "投票意见",
    "1555": "请输入投票意见",
    "1556": "同意",
    "1557": "确定要执行投票吗？",
    "1558": "投票决策仅可执行一次，确定要继续操作吗？",
    "1559": "已取消投票",
    "1560": "投票意见不能为空",
    "1561": "请选择投票类型",
    "1562": "选择开始日期时间",
    "1563": "选择结束日期时间",
    "1564": "该投票需要角色",
    "1565": "不少于",
    "1566": "投票名称不能为空",
    "1567": "投票类型不能为空",
    "1568": "投票人不能为空",
    "1569": "请选择开始时间",
    "1570": "请选择结束时间",
    "1571": "结束时间需大于当前时间1小时",
    "1572": "投票名称内容不能为空",
    "1573": "投票结果",
    "1574": "项目简称",
    "1575": "所属部门:",
    "1576": "项目描述",
    "1577": "相关会议",
    "1578": "表决结果",
    "1579": "（已选中",
    "1580": "项，共",
    "1581": "项）",
    "1582": "该文件已删除",
    "1583": "加载中",
    "1584": "】邀请您加入【",
    "1585": "】项目",
    "1586": "所属组织",
    "1587": "忽略",
    "1588": "项目文件",
    "1589": "联系人{}群组",
    "1590": "选择对象",
    "1591": "esc退出搜索",
    "1592": "交接详情",
    "1593": "指派交接",
    "1594": "交接人 【",
    "1595": "暂不处理",
    "1596": "指派选中项",
    "1597": "请选择移交人",
    "1598": "你是否满意本次版本(v1.6.0)更新？",
    "1599": "需要再用用",
    "1600": "有进步",
    "1601": "很赞",
    "1602": "产品经理：范恺",
    "1603": "产品建议、吐槽、唠嗑、养猫...",
    "1604": "欢迎扫描左侧二维码",
    "1605": "交个朋友",
    "1606": "这里是标题",
    "1607": "高级检索",
    "1608": "未填写",
    "1609": "高级筛选",
    "1610": "清空筛选条件",
    "1611": "暂未查询到与",
    "1612": "相符的内容或信息",
    "1613": "暂未查询到与之相符的内容或信息",
    "1614": "包含高级检索条件",
    "1615": "请检查输入的关键词是否有误",
    "1616": "或",
    "1617": "点击此处",
    "1618": "使用全文检索查找相关内容",
    "1619": "已锁定、有索引的、有备注的、有审批记录的、无索引的、待审批、审批中、节点审批通过、审批通过、驳回未修改、驳回已修改、修订中、修订审批中、有设置提醒的、已归档",
    "1620": "无文件、有文件",
    "1621": "{} 至 {}",
    "1622": "最小化",
    "1623": "最大化",
    "1624": "可正常发消息的群数量/可使用的群上限",
    "1625": "可正常发消息的群组(",
    "1626": "暂无群组",
    "1627": "查看已选列表",
    "1628": "当前已选数量",
    "1629": "替换",
    "1630": "不可发消息的群数量",
    "1631": "可替换群组(",
    "1632": "暂无可替换群组",
    "1633": "当前可选数量",
    "1634": "当前无选中的群组",
    "1635": "置换成功",
    "1636": "置换失败",
    "1637": "返回前台",
    "1638": "切换语言",
    "1639": "偏好设置",
    "1640": "版本说明",
    "1641": "使用帮助",
    "1642": "下载手机版",
    "1643": "信披搜索、数据中心一键直达",
    "1644": "二郎神",
    "1645": "咨询服务",
    "1646": "有新版本可更新",
    "1647": "文件处理列表",
    "1648": "下载客户端",
    "1649": "手机端下载",
    "1650": "有更新可用，刷新即可",
    "1651": "传输列表",
    "1652": "搜索（{}）",
    "1653": "检测到新的版本更新，点击「立即更新」后进行体验",
    "1654": "版本更新",
    "1655": "立即更新",
    "1656": "使用帮助手册",
    "1657": "确认退出登录吗",
    "1658": "退出失败!",
    "1659": "传输列表中，有文件进度卡在0或100不继续进行，初步判断是由于域名解析失败导致的，建议使用DNS优先进行解决。",
    "1660": "后续出现此问题不再提示",
    "1661": "前去启用",
    "1662": "稍后可在系统设置中启用DNS优选功能。",
    "1663": "若您使用DNS优选功能后，仍多次捕获到域名无法解析，您可以联系售后询问，售后电话：",
    "1664": "清除选中记录",
    "1665": "全部取消",
    "1666": "待处理文件",
    "1667": "注：请您核对上传失败版本与当前版本内容，如要上传新版本",
    "1668": "请备份后手动上传",
    "1669": "，点击定位可跳转到文件所在位置。",
    "1670": "组织名称",
    "1671": "版本进行",
    "1672": "手动解锁",
    "1673": "备份",
    "1674": "粘贴文件",
    "1675": "暂无任务",
    "1676": "文件数量",
    "1677": "进度",
    "1678": "锁定文件",
    "1679": "展示最近一次进行批量解锁时，所选文件范围内的锁定文件",
    "1680": "文件处理",
    "1681": "粘贴任务正在进行，确定要取消操作吗？",
    "1682": "成功",
    "1683": "正在准备复制",
    "1684": "正在复制",
    "1685": "暂不支持跳转客户文档",
    "1686": "清除记录成功",
    "1687": "hover 激活",
    "1688": "呕心沥血难保错误少 智能核查荣大新法宝",
    "1689": "分享的图片",
    "1690": "当前图片序号：",
    "1691": "该图片已被撤回",
    "1692": "实际大小",
    "1693": "缩小",
    "1694": "旋转",
    "1695": "{}分享的图片",
    "1696": "复制成功！",
    "1697": "复制失败，请联系管理员进行反馈！",
    "1698": "链接邀请成员",
    "1699": "组织链接",
    "1700": "分享链接，快速邀请成员加入组织。",
    "1701": "失效时间",
    "1702": "复制链接邀请",
    "1703": "“{}”邀请您加入“{}”,点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。",
    "1704": "邀请链接复制成功",
    "1705": "邀请链接复制失败",
    "1706": "邀请组织成员一起协作",
    "1707": "当前组织可用人数",
    "1708": "人",
    "1709": "可再邀请",
    "1710": "增加可用人数",
    "1711": "邀请组织成员",
    "1712": "邀请其他组织成员",
    "1713": "链接邀请",
    "1714": "邀请成功",
    "1715": "请输入成员手机号或邮箱",
    "1716": "继续添加",
    "1717": "发送邀请",
    "1718": "手机号/邮箱格式错误",
    "1719": "已邀请加入组织",
    "1720": "加入组织",
    "1721": "通过组织ID查找加入。暂无组织，点击",
    "1722": "创建组织",
    "1723": "组织ID",
    "1724": "请输入组织ID",
    "1725": "加入",
    "1726": "已提交申请",
    "1727": "请耐心等待管理员审核",
    "1728": "组织类型",
    "1729": "请输入{}ID",
    "1730": "搜索内容为空",
    "1731": "申请加入",
    "1732": "组织",
    "1733": "您可以联系组织管理者索取组织ID，申请加入对应的组织。也可以由组织成员通过您的验证邮箱或手机号邀请您加入组织。",
    "1734": "您可以联系项目负责人索取项目ID，申请加入对应的项目。也可以由项目负责人邀请您加入项目。",
    "1735": "申请加入产研项目组，项目编码:{}",
    "1736": "加入申请已发送",
    "1737": "申请加入成功",
    "1738": "拼命加载中",
    "1739": "已选",
    "1740": "邀请你加入「",
    "1741": "即刻加入",
    "1742": "协作邀请",
    "1743": "加入团队一起高效协作办公，告别繁琐和沉重的重复工作",
    "1744": "链接不存在",
    "1745": "邀请链接不存在或已失效，请联系项目管理员重新发起邀请",
    "1746": "项目加入成功",
    "1747": "链接已失效，请联系邀请人重新发送邀请",
    "1748": "消息加急提醒",
    "1749": "1、群聊内发送含@人员的消息可加急提醒单聊消息均支持加急提醒",
    "1750": "2、提醒方式可选",
    "1751": "“仅应用内”",
    "1752": "“应用内+短信”",
    "1753": "的方式。",
    "1754": "由于部分文件编码格式特殊，如遇到不能正常播放时,请下载查看",
    "1755": "您的浏览器不支持video播放",
    "1756": "该{}已被撤回",
    "1757": "暂不提示",
    "1758": "永不提示",
    "1759": "在线服务",
    "1760": "群聊的备注名称仅自己可见",
    "1761": "组织的备注名称仅自己可见",
    "1762": "操作时间",
    "1763": "操作人员",
    "1764": "账号验证",
    "1765": "当前用户",
    "1766": "登录密码",
    "1767": "请输入密码",
    "1768": "选择移交人员",
    "1769": "点击选择移交人员",
    "1770": "移交组织",
    "1771": "删除组织",
    "1772": "请选择移交人员",
    "1773": "密码不能为空",
    "1774": "最多输入50字",
    "1775": "请选择组织类型",
    "1776": "股票代码",
    "1777": "请输入股票代码(最多输入6个数字)",
    "1778": "组织简介",
    "1779": "请输入组织简介(最多输入200字)",
    "1780": "使用官方提供的初始化数据模板",
    "1781": "注：数据包含系统角色及权限、项目角色及权限、底稿目录、业务类型（含项目阶段）、任务模板、时间变量",
    "1782": "组织名称不能为空",
    "1783": "组织类型不能为空",
    "1784": "请填写正确的股票代码",
    "1785": "组织简介的字数限制为200字",
    "1786": "修改股票代码后，已经上传的股东名册数据不可见，请慎重修改!",
    "1787": "修改成功",
    "1788": "组织创建成功",
    "1789": "现在，从新建一个项目开始全面使用智慧云吧跟着引导，轻松几步就搞定",
    "1790": "稍后新建",
    "1791": "开始体验前，请先创建一个组织吧",
    "1792": "您的角色（选填）",
    "1793": "请输入(选填)",
    "1794": "暂不创建",
    "1795": "建立一个敏捷项目组，开启文档、任务等核心功能",
    "1796": "暂不",
    "1797": "请选择业务类型",
    "1798": "新建项目已提交审批！",
    "1799": "项目创建成功",
    "1800": "恭喜你已成功开启文档、任务等智慧云的核心功能，现在开始体验吧",
    "1801": "立即体验",
    "1802": "系统消息图",
    "1803": "推广活动图",
    "1804": "支持格式{}，请上传正确格式图片",
    "1805": "删除组织后：",
    "1806": "组织内所有内容（项目、文档、部门、成员等）都将永久删除，此操作不可逆，请谨慎操作",
    "1807": "当前组织已经购买的人员和空间将同步失效",
    "1808": "可用人数",
    "1809": "可用空间",
    "1810": "到期时间",
    "1811": "确定删除",
    "1812": "试用版永久免费！使用更多人员和空间，请购买正式版！",
    "1813": "{}/{}人",
    "1814": "智慧云已用空间",
    "1815": "已超总空间限制",
    "1816": "项目已用空间(包含回收站)",
    "1817": "客户文档已用空间",
    "1818": "剩余空间",
    "1819": "项目已用空间",
    "1820": "搜索项目ID/项目名称",
    "1821": "正在清空回收站，请稍候；本次计算完成后才能进行下一次清空！",
    "1822": "正在清空",
    "1823": "排名",
    "1824": "已用总空间",
    "1825": "文档已用空间",
    "1826": "文档回收站已用空间",
    "1827": "购买",
    "1828": "获取数据失败，请稍后重试",
    "1829": "空间比例计算失败，请联系管理员",
    "1830": "你确定要清空所有项目的文档回收站吗？清空后文件将无法恢复",
    "1831": "操作失败，请稍后重试",
    "1832": "获取权限失败，请稍后重试",
    "1833": "项目文档-回收站",
    "1834": "组织信息",
    "1835": "没有找到相关结果",
    "1836": "备注名（仅个人可见）",
    "1837": "暂无",
    "1838": "付费信息",
    "1839": "试用版",
    "1840": "正式版",
    "1841": "试用版永久免费！如需添加更多人员和使用空间，请购买正式版。",
    "1842": "立即购买",
    "1843": "续费",
    "1844": "成员数量",
    "1845": "扩容",
    "1846": "成员数量已超限制，请扩容",
    "1847": "系统空间",
    "1848": "系统空间已超限制，请扩容",
    "1849": "更多内容",
    "1850": "归属者",
    "1851": "退出组织",
    "1852": "删除组织后，组织内所有项目、部门、成员、文档等内容将永久删除且不可恢复，请谨慎操作",
    "1853": "一旦你退出了组织，将无法再看到该组织内的所有信息及文档，请谨慎对待",
    "1854": "确定移交组织吗？",
    "1855": "移交组织后你将不再是该组织的所属者, 仅保留管理员权限, 确定要继续移交组织吗?",
    "1856": "交接工作",
    "1857": "退出组织后，你在该组织下的所有项目将会转交给对方，由你上锁的文件将会自动解锁",
    "1858": "选择交接人员",
    "1859": "点击选择交接人员",
    "1860": "交接人不能为空",
    "1861": "退出成功",
    "1862": "已发送通知给用户",
    "1863": ", 请提醒对方查收",
    "1864": "确定退出",
    "1865": "交接人不能选本人",
    "1866": "移交后你将不再是该组织的所属者，但保留管理员权限，是否继续移交？",
    "1867": "移 交",
    "1868": "移交成功",
    "1869": "文件目录",
    "1870": "操作对象",
    "1871": "通过文档下载文件/文件夹",
    "1872": "点击外链分享",
    "1873": "通过外链分享下载文件/文件夹",
    "1874": "删除文件/文件夹",
    "1875": "修改文件",
    "1876": "新增文件/文件夹",
    "1877": "推送设置",
    "1878": "是否推送文件统计",
    "1879": "推送",
    "1880": "不推送",
    "1881": "在全部组织中不进行推送",
    "1882": "勾选后您将不接收所有组织的项目简报统计信息",
    "1883": "每天{}推送昨日文件相关数据",
    "1884": "上午10:00",
    "1885": "文件编辑模式设置",
    "1886": "选择开启以下文件类型，所有成员可对不同类型格式的文件进行多人在线编辑",
    "1887": "Word 类文件",
    "1888": "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响，请知悉！",
    "1889": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：doc | docx | dot | dotx | wps | wpt | docm)",
    "1890": "Excel 类文件",
    "1891": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：xls | xlsx | xlsm | xlt | xltx |et)",
    "1892": "PPT 类文件",
    "1893": "开启后，可对该类型文件进行多人在线编辑(文件格式包含：ppt | pptx | pptm | pps | ppsx |ppsm | potx | dpt | dps)",
    "1894": "PDF 类文件",
    "1895": "开启后，可对该类型文件进行多人在线编辑",
    "1896": "多人编辑开启后将使用WPS编辑器进行文件编辑，可能会与通过MS office编辑器进行编辑的文件产生兼容影响。如果编辑文件时对格式要求比较敏感，为了减少因兼容问题导致格式错乱的风险，建议保持使用本地编辑模式；确定继续开启多人编辑模式吗？",
    "1897": "确定开启「多人编辑」模式吗？",
    "1898": "自定义功能栏",
    "1899": "请输入任务文件夹名称",
    "1900": "完成",
    "1901": "完成并转发",
    "1902": "分享任务",
    "1903": "分享成功",
    "1904": "请填写完整",
    "1905": "请选择标签名称",
    "1906": "无标签",
    "1907": "项目名备注（仅自己可见）",
    "1908": "请输入备注名称（最多20字）",
    "1909": "取 消",
    "1910": "确 定",
    "1911": "请选择文件",
    "1912": "该文件正在审批中，不能选择",
    "1913": "锁定中的文件不能再次发起审批，请重新选择",
    "1914": "请输入文件夹名称",
    "1915": "未检索到相关内容",
    "1916": "请选择要保存的路径",
    "1917": "操作失败，图片大小不超过20M",
    "1918": "富文本编辑器图片上传",
    "1919": "启用",
    "1920": "禁用",
    "1921": "新建空白日志",
    "1922": "复用已有日志",
    "1923": "模板已启用",
    "1924": "模板已禁用",
    "1925": "你确定要删除该日志模板吗?",
    "1926": "该文件格式不支持在线编辑",
    "1927": "多人在线",
    "1928": "单人本地",
    "1929": "取消关联",
    "1930": "共{}项",
    "1931": "请输入昵称",
    "1932": "正在解锁并保存文件",
    "1933": "该文件夹已被删除，即将返回首层文件夹",
    "1934": "继续提交",
    "1935": "残忍离开",
    "1936": "不支持该类型文件上传，请重新选择",
    "1937": "支持格式{}，请上传正确格式头像",
    "1938": "头像大小不能超过10MB",
    "1939": "检测到本次上传有{}个重名对象 (文件夹/文件)",
    "1940": "更新版本",
    "1941": "为本次所有重名对象执行此操作",
    "1942": "文件重名",
    "1943": "文件上传 (",
    "1944": "重试",
    "1945": "找不到文件路径",
    "1946": "等待上传",
    "1947": "正在上传",
    "1948": "上传新版本每次只能上传一个文件",
    "1949": "无更新版本权限",
    "1950": "该文件夹下无文件，请重新选择",
    "1951": "无后缀名文件",
    "1952": "文件名称不能为空",
    "1953": "该文件超出100G限制",
    "1954": "普通文件",
    "1955": "荣大XB",
    "1956": "北交所XB",
    "1957": "文件上传成功",
    "1958": "文件上传失败，请检查网络，或选择重新上传",
    "1959": "部分文件上传失败，请检查网络，或选择重新上传",
    "1960": "当前项目进行阶段",
    "1961": "文件保存路径",
    "1962": "选择上传阶段",
    "1963": "选择粘贴阶段",
    "1964": "上传阶段",
    "1965": "粘贴阶段",
    "1966": "项目文档 / {} / 底稿上传",
    "1967": "上传文件到「",
    "1968": "上传文件到当前目录下",
    "1969": "客户文档暂不支持文件夹上传，将自动过滤",
    "1970": "搜索结果页不允许上传",
    "1971": "左侧暂无目录，无法进行上传操作",
    "1972": "很抱歉，您访问的浏览器无法使用“文件夹上传”功能！",
    "1973": "1、为了获得更好的使用体验，您可以下载最新版本的",
    "1974": "并设置成默认浏览器",
    "1975": "2、您也可以下载使用最新的荣大智慧云客户端",
    "1976": "条)",
    "1977": "标准化",
    "1978": "预 览",
    "1979": "只 读",
    "1980": "下 载",
    "1981": "当文件编辑后“",
    "1982": "大小超过20MB将无法保存成功",
    "1983": "”，建议",
    "1984": "以上的文件通过“",
    "1985": "”方式进行编辑；",
    "1986": "当文件通过“",
    "1987": "”方式时，需要注意“",
    "1988": "编辑后的",
    "1989": "文件大小不超过20MB”。",
    "1990": "注：上述问题正在努力解决中，请耐心等待…",
    "1991": "关 闭",
    "1992": "个,",
    "1993": "已驳回",
    "1994": "审批意见",
    "1995": "暂无审批意见",
    "1996": "【版本:",
    "1997": "取消回复",
    "1998": "发布",
    "1999": "条回复",
    "2000": "请输入{}审批意见，最多输入1000字",
    "2001": "审批结果",
    "2002": "通过",
    "2003": "消息通知",
    "2004": "通过站内信通知发起人查看",
    "2005": "审批回复详情",
    "2006": "共有",
    "2007": "请输入意见内容",
    "2008": "请勾选审批结果",
    "2009": "审批记录",
    "2010": "提交人",
    "2011": "审批状态",
    "2012": "未审批",
    "2013": "提审",
    "2014": "查看审批",
    "2015": "列表",
    "2016": "审批附件",
    "2017": "审批信息",
    "2018": "级审批:",
    "2019": "审批时间",
    "2020": "转交时间",
    "2021": "转交理由",
    "2022": "我的审批-我发起的-审批记录-查看-{}审批-{}审批意见页",
    "2023": "请选择要下载的数据",
    "2024": "{}-审批附件.zip",
    "2025": "批量编辑角色",
    "2026": "输入关键字搜索",
    "2027": "取消关联审批",
    "2028": "此审批流程要求您要有关联的审批",
    "2029": "提交人员",
    "2030": "是否取消该关联",
    "2031": "勾选后以下人员必须将日程抄送给我",
    "2032": "输入关键字进行过滤",
    "2033": "已选人员",
    "2034": "注：全选后新加入部门的人员自动抄送",
    "2035": "请输入人员",
    "2036": "暂未选择人员",
    "2037": "修改日程",
    "2038": "请输入日程名称",
    "2039": "请选择人员",
    "2040": "全天",
    "2041": "默认通过站内信通知发送给对方，点击x删除",
    "2042": "日程名称内容不能为空",
    "2043": "所属项目不能为空",
    "2044": "人员不能为空",
    "2045": "开始日期不能为空",
    "2046": "结束日期不能为空",
    "2047": "结束日期不能大于开始日期",
    "2048": "日期重复方式不能为空",
    "2049": "日程内容不能为空",
    "2050": "机构联系人",
    "2051": "系统角色",
    "2052": "默认的人员不能删除",
    "2053": "默认抄送人员不能删除",
    "2054": "可选人员",
    "2055": "请输入角色",
    "2056": "手机号",
    "2057": "职位",
    "2058": "编辑标签",
    "2059": "标签",
    "2060": "最多还能添加{}个",
    "2061": "按enter键进行分割",
    "2062": "最近使用的标签",
    "2063": "标签名不能相同",
    "2064": "标签最多添加10个",
    "2065": "标签名不能为空",
    "2066": "我的日程",
    "2067": "编 辑",
    "2068": "删 除",
    "2069": "新建日志",
    "2070": "请选择所属项目",
    "2071": "日志类型",
    "2072": "请选择日志类型",
    "2073": "确 认",
    "2074": "日报",
    "2075": "周报",
    "2076": "月报",
    "2077": "日志类型不能为空",
    "2078": "审批流程预览",
    "2079": "暂无附件",
    "2080": "上一步执行人",
    "2081": "指定用户",
    "2082": "指定角色",
    "2083": "前台",
    "2084": "后台",
    "2085": "部门主管",
    "2086": "发起人的",
    "2087": "级主管",
    "2088": "暂未选择审批人",
    "2089": "暂未匹配到对应的审批人",
    "2090": "暂未配置流程图",
    "2091": "已选目录",
    "2092": "请输入关键字（以空格区分）",
    "2093": "暂无相关聊天记录",
    "2094": "点击可定位到对应聊天记录",
    "2095": "昨天{}",
    "2096": "选择角色",
    "2097": "待选角色",
    "2098": "已选角色",
    "2099": "时间选择",
    "2100": "请输入操作人",
    "2101": "操作类型",
    "2102": "请选择操作类型",
    "2103": "事件",
    "2104": "导出",
    "2105": "增加目录",
    "2106": "删除目录",
    "2107": "重命名目录",
    "2108": "下载文件",
    "2109": "解锁文件",
    "2110": "重命名文件",
    "2111": "删除文件",
    "2112": "预览文件",
    "2113": "更新文件版本",
    "2114": "版本还原",
    "2115": "下载全局查看文件",
    "2116": "导出全局查看记录",
    "2117": "增加文件批注",
    "2118": "添加标签",
    "2119": "取消标签",
    "2120": "添加索引",
    "2121": "取消索引",
    "2122": "设为底稿",
    "2123": "增加目录批注",
    "2124": "关联审批",
    "2125": "关联审批（当前审批已关联审批）",
    "2126": "请选择状态",
    "2127": "提交人：",
    "2128": "请选择提交人",
    "2129": "待我审批",
    "2130": "我已审批",
    "2131": "全部（",
    "2132": "审批完成（",
    "2133": "审批中（",
    "2134": "当前审批人",
    "2135": "我发起的",
    "2136": "已撤销（",
    "2137": "抄送我的",
    "2138": "暂未选择角色",
    "2139": "待选类型",
    "2140": "已选类型",
    "2141": "暂未选择类型",
    "2142": "请输入关键字",
    "2143": "| 前台",
    "2144": "| 前台",
    "2145": "| 后台",
    "2146": "| 后台",
    "2147": "投票记录",
    "2148": "投票时间:",
    "2149": "未投票",
    "2150": "投票附件",
    "2151": "该附件被删除",
    "2152": "{}- 投票附件.zip",
    "2153": "我们正在全力搜索中，请点击",
    "2154": "刷新试试",
    "2155": "正在登录中......",
    "2156": "客户端下载",
    "2157": "关于我们",
    "2158": "高效",
    "2159": "专业",
    "2160": "协作",
    "2161": "管理",
    "2162": "登录",
    "2163": "北京荣大科技股份有限公司",
    "2164": "服务热线",
    "2165": "暂不支持IE浏览器10以下版本！请更新您的浏览器版本",
    "2166": "您已成功加入群聊",
    "2167": "新建第一个项目",
    "2168": "跟着引导，轻松几步搞定，开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "2169": "立即开始",
    "2170": "欢迎来到智慧云",
    "2171": "为了让智慧云能够更大限度的帮助你，在开始前，请帮助我们了解你",
    "2172": "选择你的机构属性",
    "2173": "进入项目",
    "2174": "查看新用户引导",
    "2175": "快速开始",
    "2176": "我们准备了「{}」常用的核心功能引导帮助你快速理解和使用智慧云！",
    "2177": "我要自行探索",
    "2178": "开始体验",
    "2179": "返回上一步",
    "2180": "数据列表",
    "2181": "请搜索版本号",
    "2182": "刷新列表",
    "2183": "新增数据",
    "2184": "链接地址",
    "2185": "说明",
    "2186": "暂无收藏项目",
    "2187": "删除后，会在联系人已关联的项目中同步进行移除",
    "2188": "公司信息",
    "2189": "离职",
    "2190": "职务：",
    "2191": "从业履历",
    "2192": "起始日期",
    "2193": "截止日期",
    "2194": "更新时间",
    "2195": "研究生",
    "2196": "请填写部门和职务",
    "2197": "编辑成功",
    "2198": "联系人详情",
    "2199": "基本信息",
    "2200": "项目经历",
    "2201": "确定要关闭页面吗？",
    "2202": "当前处于编辑状态，当前操作将不保存修改内容，确定要继续操作吗？",
    "2203": "确认要离开此页面吗？",
    "2204": "客户学历",
    "2205": "（非公开联系人仅支持在通讯录中进行查看，不支持被关联到项目）",
    "2206": "融资类型",
    "2207": "交易板块",
    "2208": "交易场所",
    "2209": "上市（挂牌）日期",
    "2210": "项目角色",
    "2211": "联系人姓名",
    "2212": "全部拒绝",
    "2213": "终止授权",
    "2214": "已授权",
    "2215": "未授权",
    "2216": "联系方式授权",
    "2217": "联系方式终止授权",
    "2218": "授权",
    "2219": "授权（{}）",
    "2220": "申请人",
    "2221": "应用项目",
    "2222": "待确认",
    "2223": "申请时间",
    "2224": "最后更新时间",
    "2225": "共",
    "2226": "客户信息",
    "2227": "统一社会信用代码",
    "2228": "企业类型",
    "2229": "法定代表人",
    "2230": "注册资本",
    "2231": "成立日期",
    "2232": "主营业务",
    "2233": "客户信息（选填）",
    "2234": "企业名称",
    "2235": "请选择企业",
    "2236": "法人代表",
    "2237": "此客户已关联，请勿重复操作！",
    "2238": "中介机构（选填）",
    "2239": "添加关联",
    "2240": "新增客户",
    "2241": "自动回显",
    "2242": "经营状态",
    "2243": "代表人职务",
    "2244": "企业地址",
    "2245": "企业标签",
    "2246": "请选择企业名称",
    "2247": "请选择客户类型",
    "2248": "当前已有内容，关闭将不予保存，确定要继续操作吗？",
    "2249": "选择企业",
    "2250": "仅支持输入中文关键词搜索",
    "2251": "与“{}”相匹配的企业",
    "2252": "没有找到相匹配的企业",
    "2253": "请输入正确的企业名称",
    "2254": "查询失败，请联系管理员",
    "2255": "企业已存在",
    "2256": "股份公司",
    "2257": "有限公司",
    "2258": "集团有限公司",
    "2259": "集团股份有限公司",
    "2260": "股份",
    "2261": "有限",
    "2262": "集团",
    "2263": "公司",
    "2264": "企业",
    "2265": "厂",
    "2266": "店",
    "2267": "馆",
    "2268": "部",
    "2269": "行",
    "2270": "中心",
    "2271": "中国",
    "2272": "中华",
    "2273": "国家",
    "2274": "更新企业信息",
    "2275": "当前客户",
    "2276": "未关联至任意组织内项目，确认要继续删除吗？",
    "2277": "客户",
    "2278": "删除后",
    "2279": "将自动从项目中移除客户信息",
    "2280": "当前客户已关联",
    "2281": "可在「项目列表」中筛选查看详情，确定要继续删除吗？",
    "2282": "确定要删除该客户吗？",
    "2283": "更新失败",
    "2284": "更新成功",
    "2285": "确定要将该人员设为离职吗？",
    "2286": "联系人「",
    "2287": "」将在企业「",
    "2288": "」下变为离职状态，确定要继续此操作吗？",
    "2289": "请维护联系人在此企业的就职时间（选填）",
    "2290": "不保留用户离职信息",
    "2291": "仅用于用户公司信息维护错误时进行修正使用",
    "2292": "确定离职",
    "2293": "确定移除",
    "2294": "客户详情",
    "2295": "联系人信息",
    "2296": "发行人",
    "2297": "保荐机构",
    "2298": "评估机构",
    "2299": "项目详情",
    "2300": "上市/发行日期",
    "2301": "联系表信息",
    "2302": "搜索行业代码/名称",
    "2303": "关联中介机构",
    "2304": "添加中介机构",
    "2305": "请选择机构",
    "2306": "请选择客户后点击确定",
    "2307": "该机构已被关联至此项目，请勿重复操作",
    "2308": "添加成功",
    "2309": "移除中介机构",
    "2310": "移除项目所关联的中介机构后，其下已被关联至此项目的联系人将会同步取消关联，确定要继续移除吗？",
    "2311": "移除成功",
    "2312": "关联通讯录联系人",
    "2313": "搜索联系人姓名",
    "2314": "关联联系人",
    "2315": "请输入联系人姓名后搜索",
    "2316": "联系人已被关联，请勿重复添加",
    "2317": "请输入联系人姓名后查询",
    "2318": "关联成功",
    "2319": "变更关联客户",
    "2320": "项目联系人",
    "2321": "查看联系人",
    "2322": "请选择客户后查看联系人",
    "2323": "确定变更关联客户吗？",
    "2324": "变更客户后，项目内成员将无法继续查看当前客户信息，确定要继续变更关联客户吗？",
    "2325": "关联机构",
    "2326": "已关联",
    "2327": "申请查看联系方式",
    "2328": "已申请查看",
    "2329": "操作助手",
    "2330": "按照以下步骤和我一起完成智慧云核心功能的操作使用吧",
    "2331": "遇到问题需要帮助？",
    "2332": "产品使用中遇到疑问，你可以向我们的产品专家在线进行询问",
    "2333": "在线咨询",
    "2334": "如何上传/新建文件？",
    "2335": "上传/新建文件",
    "2336": "「拖拽文件」到项目文档区域 或 点击「上传」按钮进行本地文件的上传，或 点击「新建」按钮进行文件新建的操作。",
    "2337": "如何对文件发起讨论？",
    "2338": "对文件发起讨论",
    "2339": "选中要发起讨论的文件，点击「发送到聊天」跳转至会话对象聊天窗口，可对发起讨论的文件进行文字说明，点击发送按钮即可。",
    "2340": "如何分享文件？",
    "2341": "选中要分享的文件，点击「外链分享」通过分享文档链接或二维码至相关人员进行查看文档内容。",
    "2342": "如何邀请项目成员？",
    "2343": "邀请项目成员",
    "2344": "点击右侧工具栏",
    "2345": "可快速邀请项目成员，邀请方式有三种：可通过1、链接邀请，2、手机号邀请，3、按群组邀请。",
    "2346": "新增「全局检索」功能",
    "2347": "新增对文件、联系人/群组、聊天记录的全局检索功能，点击全局检索入口或",
    "2348": "快速唤起全局检索弹框，可以对任意组织、任意项目中的文件、联系人进行检索",
    "2349": "关闭当前页",
    "2350": "关闭所有内容(共{}条)",
    "2351": "新功能上线",
    "2352": "新应用上架",
    "2353": "活动开始啦",
    "2354": "单独删除",
    "2355": "全部删除",
    "2356": "新增「项目文档窗体独立」功能",
    "2357": "将不同组织中不同项目的文档页面作为独立窗口打开，可以更快捷的实现跨组织/项目编辑和查看文件，你可以自由设置想要打开的项目文档，让文件编辑更加便捷、高效",
    "2358": "新增「文件收藏」功能",
    "2359": "你可以将近期经常使用或阶段性工作的文件添加到收藏，通过已收藏的文件快速找到项目文件并开始工作，提高在众多文件夹中查找目标文件的效率",
    "2360": "请选择中介机构名称",
    "2361": "点击选择业务类型",
    "2362": "字段获取错误，{}",
    "2363": "有时间",
    "2364": "无时间",
    "2365": "点击选择部门",
    "2366": "包含任一",
    "2367": "包含全部",
    "2368": "点击选择审批类型",
    "2369": "点击选择人员",
    "2370": "创建网查任务",
    "2371": "输入关键词搜索",
    "2372": "筛选",
    "2373": "链接",
    "2374": "添加筛选条件",
    "2375": "发送人",
    "2376": "@消息:",
    "2377": "请输入检索条件",
    "2378": "你可能想找",
    "2379": "最近联系过",
    "2380": "点击查看更多",
    "2381": "已展示全部结果",
    "2382": "没有找到关于",
    "2383": "群组",
    "2384": "群聊名称",
    "2385": "最近搜索",
    "2386": "选择{}",
    "2387": "未检索到数据",
    "2388": "标题",
    "2389": "匹配全部关键字 空格区分",
    "2390": "匹配任一关键词 空格区分",
    "2391": "不匹配关键词 空格区分",
    "2392": "结果展示顺序",
    "2393": "按时间排序",
    "2394": "按匹配度排序",
    "2395": "内容：",
    "2396": "匹配全部关键词 空格区分",
    "2397": "文档范围",
    "2398": "点击选择",
    "2399": "文件大小",
    "2400": "大小输入有误，请调整",
    "2401": "本次检索结果",
    "2402": "全部展开",
    "2403": "全部收起",
    "2404": "请先加入组织后，进行文件检索",
    "2405": "请输入检索条件后查询",
    "2406": "反馈",
    "2407": "网查工具使用体验调研",
    "2408": "感谢使用「智能网查」应用，为了进一步提升你的使用体验，请花2-3分钟时间反馈一下你使用「智能网查」的体验，产品后续怎么优化，想听听你的建议",
    "2409": "我要评论",
    "2410": "我要提建议",
    "2411": "我有产品需求",
    "2412": "请选择要评论的任务",
    "2413": "请评价你对本次任务执行的满意度",
    "2414": "1、网站满足需求程度",
    "2415": "2、查询结果满意程度",
    "2416": "3、查询结果精确程度",
    "2417": "4、查询速度满意程度",
    "2418": "5、操作易用性的满意程度",
    "2419": "你愿意推荐他人使用「智能网查」应用吗？",
    "2420": "其他问题评论",
    "2421": "还有其他问题要评论？请在这里输入",
    "2422": "上传图片附件",
    "2423": "图片支持jpg、png格式，最大不超过 5 M",
    "2424": "请选择问题分类",
    "2425": "问题描述",
    "2426": "需求标题",
    "2427": "请概述一下你的需求",
    "2428": "请描述一下该需求的业务场景和背景",
    "2429": "请具体描述一下你需要的是什么",
    "2430": "你的反馈对我们提升更好的使用体验有着至关重要的帮助，确定要离开吗？",
    "2431": "关于查询速度问题",
    "2432": "关于使用的便利性问题",
    "2433": "关于查询查询网站问题",
    "2434": "关于缺陷问题",
    "2435": "大于5M图片不可上传",
    "2436": "网查应用内",
    "2437": "{}的评论已提交成功",
    "2438": "移入此区域显示「刷新」，刷新该文件夹内容",
    "2439": "存在筛选条件",
    "2440": "请输入标题关键字 以空格区分",
    "2441": "在“项目文档”中搜索",
    "2442": "在“底稿视图”中搜索",
    "2443": "在\"{}...\"中搜索",
    "2444": "在\"{}\"中搜索",
    "2445": "开始",
    "2446": "系统通知",
    "2447": "加急消息",
    "2448": "基础信息",
    "2449": "请输入姓名,最多可输入10字符",
    "2450": "请选择性别",
    "2451": "手机",
    "2452": "已绑定",
    "2453": "未绑定",
    "2454": "需前往[荣大科技-账号安全]进行修改",
    "2455": "立即绑定",
    "2456": "请输入手机号",
    "2457": "不对外显示号码",
    "2458": "请输入邮箱",
    "2459": "请输入公司名称",
    "2460": "请输入部门",
    "2461": "请输入职位",
    "2462": "姓名不能为空",
    "2463": "手机不能为空",
    "2464": "性别不能为空",
    "2465": "不允许输入\\\\符号",
    "2466": "修改个人信息成功",
    "2467": "原密码",
    "2468": "请输入原密码",
    "2469": "密码为6-18位数字与字母组合",
    "2470": "新密码",
    "2471": "请输入新密码",
    "2472": "确认密码",
    "2473": "请再次输入新密码",
    "2474": "修改密码成功！请重新登录",
    "2475": "权益信息",
    "2476": "权益包大集合",
    "2477": "荣大公司交付的权益包集合，无需再次付费即可一键充值使用",
    "2478": "支持对权益包进行多次转让他人后充值使用，也方便查看权益包的使用详情",
    "2479": "前往查看",
    "2480": "账号注销",
    "2481": "信息",
    "2482": "共计提审",
    "2483": "请输入选择",
    "2484": "请输入申请内容",
    "2485": "抄送方式",
    "2486": "审批通过后通知",
    "2487": "将会对底稿管理中选中目录发起审批",
    "2488": "将会对项目文档中选中文件发起审批",
    "2489": "将会对底稿视图中选中文件发起审批",
    "2490": "您暂无项目权限，不可发起审批",
    "2491": "请到底稿管理选择目录后发起审批",
    "2492": "请到项目文档/底稿管理选择文件后发起审批",
    "2493": "当前无选中{}",
    "2494": "归档文件无法发起审批",
    "2495": "所选文件中存在锁定文件，无法发起审批",
    "2496": "请先选择可审批的{}",
    "2497": "发起审批时，归档文件将自动过滤，确定要继续操作吗？",
    "2498": "仅审批通过的{}可发起修订审批",
    "2499": "仅审批通过的{}可发起审批，其他{}将自动过滤",
    "2500": "确认关闭",
    "2501": "请勾选想要删除的附件",
    "2502": "{}文件已存在",
    "2503": "请选部门",
    "2504": "提交审批成功",
    "2505": "收藏项目",
    "2506": "修改备注名",
    "2507": "独立项目窗口",
    "2508": "独立窗口数量已达上限",
    "2509": "最多可同时打开{}个独立窗口，请关闭其他已打开窗口再操作",
    "2510": "关联索引",
    "2511": "排序",
    "2512": "已选中",
    "2513": "项",
    "2514": "文件编辑模式支持「本地编辑」或「多人编辑」",
    "2515": "编辑预览说明",
    "2516": "本地编辑模式或多人编辑模式通过开关进行切换",
    "2517": "显示为仅可预览或不可预览的文件格式，不支持本地/多人编辑",
    "2518": "多人",
    "2519": "本地",
    "2520": "确定切换到「多人编辑模式」吗？",
    "2521": "该模式不兼容部分office功能，对文档排版格式有影响，确定继续切换吗？",
    "2522": "在线编辑模式",
    "2523": "本地编辑模式",
    "2524": "仅可预览",
    "2525": "不可预览",
    "2526": "正在保存",
    "2527": "备注{}条",
    "2528": "文件已删除，不能预览",
    "2529": "文件名已存在，新文件将以「{}」进行命名",
    "2530": "是否同步修改任务名称？",
    "2531": "请选择一个项目进行操作",
    "2532": "新建中",
    "2533": "{} 的 {}",
    "2534": "{}的{}",
    "2535": "的",
    "2536": "日志抄送人",
    "2537": "暂无抄送人",
    "2538": "复用该日志",
    "2539": "{}的{}日志",
    "2540": "确定要复用该日志吗？",
    "2541": "有正在编辑的草稿内容，当前操作将清空所有内容，确定要继续操作吗？",
    "2542": "复用日志",
    "2543": "数据获取失败，请关闭窗口重试",
    "2544": "暂无可复用的日志",
    "2545": "超出最大人数限制",
    "2546": "按组织架构选择",
    "2547": "按项目选择",
    "2548": "接口信息获取失败",
    "2549": "当前组织下无成员和子部门",
    "2550": "当前组织下无项目",
    "2551": "按组织结构选择",
    "2552": "{}({}人)",
    "2553": "按成员选择",
    "2554": "已存在",
    "2555": "底稿管理-{}审批意见页",
    "2556": "项目文档-文件审批意见页",
    "2557": "请选择{}",
    "2558": "将要删除文件",
    "2559": "关联文件位置",
    "2560": "被索引情况",
    "2561": "解锁中",
    "2562": "上锁时间",
    "2563": "锁类型",
    "2564": "锁定人",
    "2565": "正在解锁",
    "2566": "文件位置",
    "2567": "手动锁定",
    "2568": "异常锁定",
    "2569": "系统锁定",
    "2570": "我锁定的",
    "2571": "他人锁定的",
    "2572": "由项目成员进行手动锁定的文件",
    "2573": "系统检测到无人正在进行编辑，但文件并未正常解锁的情况，将被识别为文件异常锁定",
    "2574": "系统检测到正在进行编辑的文件，或因业务操作被系统锁定的文件不可被解锁",
    "2575": "操作失败",
    "2576": "本地编辑锁定",
    "2577": "多人编辑锁定",
    "2578": "搜索结果页不可以使用目录模板",
    "2579": "请先选择项目",
    "2580": "引用成功",
    "2581": "请选择想要复制的文件或文件夹",
    "2582": "当前无选中文件",
    "2583": "归档文件不可拖动剪切",
    "2584": "搜索结果页不允许剪切",
    "2585": "剪切成功",
    "2586": "已删除的文件可通过回收站还原，该文件已关联底稿文件",
    "2587": "关联的底稿文件将无法还原，确定要继续删除吗？",
    "2588": "确认要把文件放入回收站吗？文件已关联为底稿文件，将一同删除，删除的文件可随时在回收站里还原，但关联文件不能还原。",
    "2589": "正在删除...",
    "2590": "删除成功，删除的文档可以从「回收站」中恢复",
    "2591": "审批中的文件不能删除，请重新选择。",
    "2592": "审批通过的文件不能删除，请重新选择。",
    "2593": "确定要删除选中的内容吗？",
    "2594": "路径",
    "2595": "已删除的文件/文件夹可通过回收站还原，确定要继续删除吗？",
    "2596": "此操作仅删除底稿文件，项目文档中的原始文件不受影响，确定要继续删除吗？",
    "2597": "已删除的文件/文件夹将无法恢复，确定要继续删除吗？",
    "2598": "已添加至收藏！",
    "2599": "没有可上锁的数据",
    "2600": "批量上锁成功",
    "2601": "该文件已加锁",
    "2602": "审批中/审批通过的文件不可手动解锁！",
    "2603": "该文件已锁定，是否解锁",
    "2604": "确定要锁定该文件吗？",
    "2605": "锁定后，该文件无法编辑，确定要锁定吗？",
    "2606": "取消锁定",
    "2607": "搜索结果页不允许新建",
    "2608": "使用PDF Reader Pro与PDF Reader，未编辑内容关闭文件；",
    "2609": "使用浏览器编辑PDF文件；",
    "2610": "上述两种方式会造成文件锁定异常，需通过人工手动解除锁定。",
    "2611": "请确认本地已经安装pdf编辑软件",
    "2612": "未安装时进行本地编辑会造成文件锁定异常，需通过人工手动解除锁定",
    "2613": "继续编辑",
    "2614": "使用Numbers表格、Pages文稿、Keynote讲演进行单人本地编辑时，无法自动生成新版本，您可以采用手动上传的方式将本地已经编辑完成的文件进行上传。",
    "2615": "终止项目不支持引用模板",
    "2616": "搜索结果页不允许引用在线模板",
    "2617": "搜索结果页不允许粘贴",
    "2618": "请先选择目录",
    "2619": "请先复制粘贴文件",
    "2620": "请先复制文件或文件夹",
    "2621": "不能跨项目剪切",
    "2622": "请先复制文件",
    "2623": "正在剪切",
    "2624": "索引粘贴成功",
    "2625": "选择接收人",
    "2626": "仅支持勾选一个",
    "2627": "请先选择文件",
    "2628": "文件解锁成功",
    "2629": "无法对文件夹进行备注，请选择要备注的文件",
    "2630": "已选文件列表",
    "2631": "关键字",
    "2632": "包含以下全部关键字(以空格区分)",
    "2633": "请选择项目阶段",
    "2634": "已修订",
    "2635": "索引",
    "2636": "不可操作",
    "2637": "所在阶段",
    "2638": "所在目录",
    "2639": "生成",
    "2640": "底稿关联",
    "2641": "我的审批-{}审批-版本",
    "2642": "文件审批搜索结果",
    "2643": "有讨论的",
    "2644": "文件/文件夹",
    "2645": "目录修订审批",
    "2646": "{}搜索结果",
    "2647": "系统异常",
    "2648": "主工作台-我的审批-审批-审批记录",
    "2649": "请选择文件后点击版本",
    "2650": "请选择单个文件后点击版本",
    "2651": "当前无选中目录",
    "2652": "我的审批-{}审批-{}审批意见页",
    "2653": "该{}{},无法再进行审批",
    "2654": "该{}已被其他节点驳回,无法再进行审批",
    "2655": "请先选择可审批的目录",
    "2656": "已在其他审批中进行/审批通过的文件不能再进行审批，进行审批时将自动过滤。源文件及索引文件进行审批时，所有审批意见及审批状态将进行同步?",
    "2657": "已在其他审批中进行/审批通过的目录和本次未提审的待审批目录不能进行审批，进行审批时将自动过滤",
    "2658": "审批确认",
    "2659": "请先选择可审批的文件",
    "2660": "{}审批",
    "2661": "{}审批意见",
    "2662": "我的审批-{}审批-备注",
    "2663": "{}审批查询",
    "2664": "{}/{}/{}审批查询",
    "2665": "请选中{}后点击下载",
    "2666": "我的审批-{}审批",
    "2667": "当前无选中{}，请选择您要导出的{}",
    "2668": "我的审批-文件审批-文件审批搜索结果",
    "2669": "相关信息",
    "2670": "共计",
    "2671": "，已审",
    "2672": "个，待审",
    "2673": "去审",
    "2674": "）个",
    "2675": "节点审批",
    "2676": "文件修订审批意见",
    "2677": "目录修订审批意见",
    "2678": "转交",
    "2679": "请输入审批意见，最多输入1000字",
    "2680": "抄送人(抄送方式:整体审批完成后抄送)",
    "2681": "新建日程提醒",
    "2682": "我的审批-{}审批-节点审批-{}审批意见页",
    "2683": "所属行业",
    "2684": "成立时间",
    "2685": "联系电话",
    "2686": "所属部门",
    "2687": "团队信息",
    "2688": "借阅信息",
    "2689": "记录",
    "2690": "抄送人：",
    "2691": "级审批",
    "2692": "审批时间：",
    "2693": "审批文件",
    "2694": "文件审批记录",
    "2695": "平方根几号放假",
    "2696": "关联会议",
    "2697": "选择会议",
    "2698": "请选择会议",
    "2699": "我选中的会议",
    "2700": "新增会议",
    "2701": "取消关联提醒",
    "2702": "关联投票",
    "2703": "选择投票",
    "2704": "请选择投票",
    "2705": "我选中的投票",
    "2706": "新增投票",
    "2707": "取消投票关联提醒",
    "2708": "没有关联的投票",
    "2709": "请输入投票名称",
    "2710": "只能上传jpg/png文件，且不超过500kb",
    "2711": "转交人员",
    "2712": "请输入转交理由",
    "2713": "最多输入400字",
    "2714": "请选择转交人员",
    "2715": "会议主题内容不能为空",
    "2716": "会议类型内容不能为空",
    "2717": "结束时间不能为空",
    "2718": "参会人员不能为空",
    "2719": "取消成功!",
    "2720": "已取消",
    "2721": "是否取消该关联投票",
    "2722": "投票人员不能为空",
    "2723": "{}小时",
    "2724": "待审目录",
    "2725": "请选择审批结果",
    "2726": "请审批文件",
    "2727": "请审批目录",
    "2728": "当前附件全部未通过",
    "2729": "{}提醒您审批他的{}",
    "2730": "确认要撤销审批吗？",
    "2731": "主工作台",
    "2732": "撤销",
    "2733": "催办",
    "2734": "去审文件",
    "2735": "去审目录",
    "2736": "审批结果：",
    "2737": "此审批流程要求您要有关联的投票",
    "2738": "选择抄送人员",
    "2739": "您有未审批文件，请全部审批",
    "2740": "{} ：提醒您尽快审批关于{}{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为{}",
    "2741": "请输入名称",
    "2742": "请输入所属项目",
    "2743": "类型",
    "2744": "请选择类型",
    "2745": "事件名称",
    "2746": "事件类型",
    "2747": "日程抄送设置",
    "2748": "请选择抄送人",
    "2749": "新建日程",
    "2750": "默认通过站内信通知发送给对方，点击{}删除",
    "2751": "抄送我的日程",
    "2752": "周",
    "2753": "年",
    "2754": "开始前15分钟",
    "2755": "开始前1小时",
    "2756": "开始前3小时",
    "2757": "开始前1天",
    "2758": "结束日期不能小于于开始日期",
    "2759": "当前有草稿内容，是否要引用？",
    "2760": "内容不能为空",
    "2761": "七",
    "2762": "八",
    "2763": "九",
    "2764": "十",
    "2765": "十一",
    "2766": "十二",
    "2767": "从借阅成功起，借阅时限为{}小时超过借阅时限后",
    "2768": "借阅文件",
    "2769": "自动失效",
    "2770": "无法查看",
    "2771": "是否确定借阅？",
    "2772": "请输入项目编码",
    "2773": "访问来源",
    "2774": "移除全部已删除文件",
    "2775": "已取消收藏",
    "2776": "已移除",
    "2777": "待检验目录",
    "2778": "更改位置",
    "2779": "目录文件",
    "2780": "选择文件",
    "2781": "校验规则",
    "2782": "检验列: sheet 1, A列",
    "2783": "请选择待检验目录",
    "2784": "请选择目录文件",
    "2785": "文件大小超出限制，上限为10M",
    "2786": "目录检验中，完成后将推送系统消息，请稍后...",
    "2787": "待提取目录",
    "2788": "提取文件保存位置",
    "2789": "[Excel提取文件]",
    "2790": "请选择待提取目录",
    "2791": "请选择提取文件保存位置",
    "2792": "文件提取中，完成后将推送系统消息，请稍后...",
    "2793": "待导出目录",
    "2794": "导出内容",
    "2795": "文件 + 文件夹",
    "2796": "请选择待导出目录",
    "2797": "执行失败,请重试",
    "2798": "目录导出中，完成后将推送系统消息，请稍后...",
    "2799": "功能演示",
    "2800": "tips: 需等数分钟, 检验完成后将推送消息",
    "2801": "tips: 导出的目录只支持当下的50个层级",
    "2802": "检测",
    "2803": "提取",
    "2804": "检验",
    "2805": "创建群聊",
    "2806": "创建项目群",
    "2807": "不允许上传文件夹",
    "2808": "所要加入项目",
    "2809": "手机号邀请",
    "2810": "按群组邀请",
    "2811": "组织成员席位",
    "2812": "请输入正确格式的手机号",
    "2813": "请选择邀请人员",
    "2814": "搜索日志模板标题",
    "2815": "最近使用",
    "2816": "更多模板",
    "2817": "看成是大家",
    "2818": "看fsd",
    "2819": "擦第三方ads",
    "2820": "项目统计{}进度状态{}",
    "2821": "项目进度",
    "2822": "项目编号",
    "2823": "负责人",
    "2824": "整体完成度",
    "2825": "事项名称",
    "2826": "事项类型",
    "2827": "最新消息",
    "2828": "{}的项目日志",
    "2829": "的项目日志",
    "2830": "会议名称",
    "2831": "结束日期不能小于开始日期",
    "2832": "设置提醒后，有版本变动的文件将会在\"消息中心\"红点标记提醒！",
    "2833": "关闭提醒后，该文件对所有人的提醒均关闭！",
    "2834": "提醒人员",
    "2835": "添加人员",
    "2836": "添加角色",
    "2837": "选择的文件",
    "2838": "关闭提醒",
    "2839": "未选中要关闭的文件",
    "2840": "您已成功关闭本人设置的文件提醒",
    "2841": "请在提醒人员中添加人员或者角色",
    "2842": "请重新选择要提醒的文件",
    "2843": "文件设置提醒成功",
    "2844": "批量编辑关联",
    "2845": "选择要创建关联的文件",
    "2846": "请输入关键词搜索",
    "2847": "选择要关联的目标文件",
    "2848": "底稿文档",
    "2849": "右侧只能选择一个文件",
    "2850": "请选择要创建关联的文件",
    "2851": "请选择要关联的目标文件",
    "2852": "{}不能关联本身",
    "2853": "编辑底稿关联",
    "2854": "此文件已是锁定状态，不能再次添加",
    "2855": "文件不能关联本身",
    "2856": "已删除的文件不能被关联",
    "2857": "全文检索",
    "2858": "所在项目",
    "2859": "搜索条件不能为空",
    "2860": "首页",
    "2861": "借阅剩余时限",
    "2862": "已经到底了~",
    "2863": "{}分钟",
    "2864": "请选中数据进行下载或批量下载(注：锁定文件和不可操作文件是不能下载的)",
    "2865": "所选数据包含锁定文件不能删除",
    "2866": "此操作将永久删除该文件, 是否继续?",
    "2867": "数据过多正在删除中",
    "2868": "请选择数据进行删除",
    "2869": "此处删除只能删除单条",
    "2870": "所选数据包含锁定文件不能重命名",
    "2871": "名字不能为空",
    "2872": "所选数据包含锁定文件不能剪切",
    "2873": "当前选中有目录数据,暂不支持目录的剪切操作",
    "2874": "当前文件锁定成功",
    "2875": "当前文件未能锁定成功",
    "2876": "此处锁定只能锁定单条",
    "2877": "当前文件解锁成功",
    "2878": "当前文件未能解锁成功",
    "2879": "删除成功(含有文件锁或特殊文件是不允许删除的)",
    "2880": "编辑失败",
    "2881": "您确定要使用{}来当作文件的名字",
    "2882": "粘贴成功",
    "2883": "服务评价",
    "2884": "请对本次服务进行评价,您的评价有助于我们为您提供更好的服务!",
    "2885": "服务人员",
    "2886": "服务类型",
    "2887": "服务项目",
    "2888": "产品质量",
    "2889": "服务态度",
    "2890": "工作效率",
    "2891": "专业技能",
    "2892": "服务描述",
    "2893": "请您对本次服务做出评价最对200个字",
    "2894": "收藏此服务员",
    "2895": "匿名评价",
    "2896": "提交评价",
    "2897": "讨论对象",
    "2898": "待我执行({})",
    "2899": "抄送我的({})",
    "2900": "我创建的({})",
    "2901": "我完成的({})",
    "2902": "取消完成",
    "2903": "标记完成",
    "2904": "上次打开",
    "2905": "搜索任务名称",
    "2906": "请选择任务",
    "2907": "是否要取消完成所有选中的任务 是否继续?",
    "2908": "{}个任务取消成功，{}个任务取消失败",
    "2909": "确定要标记完成所有选中的任务吗？",
    "2910": "标记",
    "2911": "全部{}成功",
    "2912": "{}个任务{}成功，{}个任务{}失败",
    "2913": "任务不存在",
    "2914": "创建或加入组织",
    "2915": "创建属于你的组织，邀请成员一起协作办公，或点击",
    "2916": "现在，从新建一个项目开始全面使用智慧云吧",
    "2917": "开启智慧云文档、任务等核心功能，并邀请成员一起在线协作",
    "2918": "席位",
    "2919": "试用版永久免费",
    "2920": "拖拽排序",
    "2921": "可对任务进行拖拽排序",
    "2922": "更多选项",
    "2923": "Excel模板",
    "2924": "导入模板",
    "2925": "全部任务(含附件)",
    "2926": "仅任务总览",
    "2927": "导出任务",
    "2928": "默认顺序",
    "2929": "恢复任务初始顺序",
    "2930": "还原顺序",
    "2931": "还原移动前顺序",
    "2932": "高级",
    "2933": "请输入任务名称,多个请用空格隔开",
    "2934": "点击选择创建人",
    "2935": "请选择优先级",
    "2936": "请选择逾期状态",
    "2937": "请选择任务状态",
    "2938": "看板视图",
    "2939": "列表视图",
    "2940": "概览视图",
    "2941": "进行中",
    "2942": "逾期进行中",
    "2943": "逾期已完成",
    "2944": "待我执行",
    "2945": "我创建的",
    "2946": "我完成的",
    "2947": "全部任务(0)",
    "2948": "导入成功",
    "2949": "无任务导出",
    "2950": "网页端暂不支持此功能，请下载客户端操作",
    "2951": "定位项目群",
    "2952": "快速打开当前项目群聊窗口",
    "2953": "查看当前已打开项目任务",
    "2954": "邀请更多人员加入当前项目",
    "2955": "是否打开消息独立窗口并定位到对应的项目群？",
    "2956": "去到消息页面",
    "2957": "请先加入项目",
    "2958": "暂无邀请权限，请去联系项目创建人",
    "2959": "进行配置",
    "2960": "删除时间",
    "2961": "请选取至少一条数据",
    "2962": "您确定要还原文件？",
    "2963": "还原中...",
    "2964": "您确定要彻底删除文件？",
    "2965": "您确定要清空回收站？清空后文件将无法恢复",
    "2966": "清空回收站成功!",
    "2967": "个人网盘搜索结果页",
    "2968": "已使用空间",
    "2969": "没有说明",
    "2970": "版本名称",
    "2971": "请输入版本名称，如：1.0",
    "2972": "升级类型",
    "2973": "请选择升级类型",
    "2974": "不强制升级",
    "2975": "强制升级",
    "2976": "静默升级",
    "2977": "是否包含前端包",
    "2978": "请选择包含前端包",
    "2979": "不包含",
    "2980": "升级的环境",
    "2981": "请选择需要升级的环境",
    "2982": "开发",
    "2983": "测试",
    "2984": "产研",
    "2985": "正式",
    "2986": "环境ip",
    "2987": "跟升级环境对应的ip",
    "2988": "升级包地址",
    "2989": "请输入升级包地址",
    "2990": "pc升级验证",
    "2991": "请输入pc升级验证",
    "2992": "发布时间",
    "2993": "请选择产品的发布时间",
    "2994": "升级说明 {}",
    "2995": "请直接输入说明，注意不要输入序号！",
    "2996": "新增说明项",
    "2997": "删除此说明项",
    "2998": "请输入版本名称",
    "2999": "请选择是否包含前端包",
    "3000": "请选择升级环境",
    "3001": "请输入跟升级环境对应的ip",
    "3002": "请选择发布时间",
    "3003": "升级说明不允许为空",
    "3004": "此操作将永久删除该记录, 是否继续?",
    "3005": "升级标识",
    "3006": "请选择升级标识",
    "3007": "不用升级",
    "3008": "可选升级",
    "3009": "下载链接",
    "3010": "文案描述",
    "3011": "平台信息",
    "3012": "请选平台信息",
    "3013": "版本号不能为空",
    "3014": "版本号为数字",
    "3015": "升级标识不能为空",
    "3016": "下载链接不能为空",
    "3017": "文案描述不能为空",
    "3018": "平台信息不能为空",
    "3019": "新增失败",
    "3020": "下级部门",
    "3021": "增加子部门",
    "3022": "部门名称",
    "3023": "上移",
    "3024": "下移",
    "3025": "部门成员",
    "3026": "增加人员",
    "3027": "调整部门",
    "3028": "是否部门主管",
    "3029": "增加部门名称",
    "3030": "投资银行部",
    "3031": "请选择成员",
    "3032": "确定删除该人员吗?",
    "3033": "删除提示",
    "3034": "已经是第一条了",
    "3035": "已经是最后一条",
    "3036": "名称不能为空",
    "3037": "删除部门会删除部门下的所有子部门以及人员, 确定删除吗?",
    "3038": "新建流程",
    "3039": "版本管理",
    "3040": "流程名称",
    "3041": "变更理由",
    "3042": "是否为主版本",
    "3043": "主版本",
    "3044": "设置主版本",
    "3045": "人员配置",
    "3046": "审批人员",
    "3047": "选择用户",
    "3048": "无主管时，可由上级主管代批",
    "3049": "注：审批人为空时自动转交给管理员。",
    "3050": "已发布",
    "3051": "直接主管（1级主管）",
    "3052": "2级主管",
    "3053": "3级主管",
    "3054": "4级主管",
    "3055": "5级主管",
    "3056": "设置成功",
    "3057": "主版本不可删除",
    "3058": "此操作将永久删除该流程, 是否继续?",
    "3059": "请选择人员配置",
    "3060": "请选择指定用户",
    "3061": "请选择指定角色",
    "3062": "流程引擎搜索结果",
    "3063": "新增流程",
    "3064": "请输入关键词",
    "3065": "请先选择业务类型",
    "3066": "请选择一个业务类型",
    "3067": "开启流程审批",
    "3068": "关闭流程审批",
    "3069": "关联项目审批",
    "3070": "关闭关联项目审批",
    "3071": "描述",
    "3072": "流程",
    "3073": "保存并关闭",
    "3074": "未发布",
    "3075": "禁用中",
    "3076": "启用中",
    "3077": "去补充",
    "3078": "编辑流程",
    "3079": "请先保存修改内容",
    "3080": "只有状态为启用中的时候才能开启审批流程",
    "3081": "开启审批流程",
    "3082": "关闭审批流程",
    "3083": "只有开启审批流程之后才能开起关联项目审批",
    "3084": "开启关联审批流程",
    "3085": "关闭关联审批流程",
    "3086": "发布成功",
    "3087": "启用成功",
    "3088": "禁用成功",
    "3089": "所选审批人中{}",
    "3090": "{}抄送人中{}",
    "3091": "账号异常，请先编辑处理，否则将可能导致审批流程无法正常进行。",
    "3092": "流程图不完整无法启用该审核，请补充流程图",
    "3093": "业务类型内容不能为空",
    "3094": "审核类型内容不能为空！",
    "3095": "项目阶段内容不能为空",
    "3096": "保存成功",
    "3097": "请先选择流程",
    "3098": "请至少选择一条数据",
    "3099": "请先复制流程",
    "3100": "搜索角色",
    "3101": "无匹配数据",
    "3102": "创建角色副本",
    "3103": "可操作功能",
    "3104": "可访问数据",
    "3105": "项目数据",
    "3106": "客户数据",
    "3107": "个人日志数据",
    "3108": "数据源",
    "3109": "请先复制角色权限",
    "3110": "创建角色副本成功",
    "3111": "请选择权限",
    "3112": "请输入角色名称",
    "3113": "角色名称不能超过20个字符",
    "3114": "确定要删除选中的角色吗？",
    "3115": "请输入正确的角色名称",
    "3116": "选择时间",
    "3117": "日志分类",
    "3118": "请选日志分类",
    "3119": "底稿报送",
    "3120": "事件内容",
    "3121": "包含以下全部关键词（以空格区分）",
    "3122": "包含以下全部关键词（以空格区分",
    "3123": "操作用户",
    "3124": "请选择用户",
    "3125": "历史年度数据导出",
    "3126": "用户名",
    "3127": "选择导出年度",
    "3128": "导出当年",
    "3129": "上一年",
    "3130": "选择年",
    "3131": "工作",
    "3132": "用户",
    "3133": "检索日志",
    "3134": "组织消息",
    "3135": "开始时间不能晚于结束时间",
    "3136": "结束时间不能早于开始时间",
    "3137": "请输入开始日期",
    "3138": "请输入结束日期",
    "3139": "开始日期不能大于当前日期",
    "3140": "结束日期不能小于当前日期",
    "3141": "正在导出",
    "3142": "请选择时间",
    "3143": "角色",
    "3144": "退出时间",
    "3145": "拒绝",
    "3146": "荣大",
    "3147": "荣大-人员",
    "3148": "该操作将该成员取消邀请，是否继续？",
    "3149": "取消邀请成功",
    "3150": "员工名称",
    "3151": "请输入关键字,多个请用空格隔开",
    "3152": "离开时间",
    "3153": "已加入",
    "3154": "邀请中",
    "3155": "申请中",
    "3156": "请选择角色",
    "3157": "请选中人员",
    "3158": "系统异常, 请刷新页面",
    "3159": "同意成功",
    "3160": "拒绝成功",
    "3161": "修改人员",
    "3162": "请输入姓名",
    "3163": "姓名长度不能超过20",
    "3164": "请填写完整资料",
    "3165": "手机号格式错误，请重试",
    "3166": "身份证号不正确，请重试",
    "3167": "职位输入有误，职位名由汉字或字母组成",
    "3168": "确定要删除{}吗, 是否继续?",
    "3169": "收回独立窗口",
    "3170": "置顶独立窗口",
    "3171": "搜索组织",
    "3172": "上次组织",
    "3173": "全部组织",
    "3174": "项目名称:",
    "3175": "快速 「切换组织项目」 上线啦",
    "3176": "可切换其他组织下的项目",
    "3177": "变更时间",
    "3178": "变更日志",
    "3179": "客户姓名",
    "3180": "客户变更",
    "3181": "联系人变更",
    "3182": "新增",
    "3183": "项目关联",
    "3184": "推送列表",
    "3185": "推送名称",
    "3186": "执行状态",
    "3187": "推送内容",
    "3188": "用户名称",
    "3189": "请输入用户名称",
    "3190": "发送时间",
    "3191": "再次发送",
    "3192": "确定要再次发送此推送消息吗？",
    "3193": "发送成功",
    "3194": "发送中，合计发送 {} 人",
    "3195": "已完成，合计发送 {} 人，失败 {} 人",
    "3196": "正在导出!",
    "3197": "新建推送",
    "3198": "推送名称：",
    "3199": "请输入推送名称",
    "3200": "请输入创建人",
    "3201": "发送中，合计发送{}人",
    "3202": "已完成，合计发送{}人，失败{}人",
    "3203": "推送次数",
    "3204": "发送详情",
    "3205": "发送主体设置",
    "3206": "发送主体",
    "3207": "系统广告",
    "3208": "系统活动",
    "3209": "请选择接收人",
    "3210": "是否发送全局消息通知？",
    "3211": "发送链接为:",
    "3212": "内容设置",
    "3213": "请输入推送名称 (不超过字)",
    "3214": "有效期",
    "3215": "分享卡片标题",
    "3216": "分享卡片内容",
    "3217": "通知内容",
    "3218": "传输协议",
    "3219": "站内跳转",
    "3220": "ibsaasActivity.html为默认活动页路径",
    "3221": "APP推广通知",
    "3222": "请选择终端",
    "3223": "安卓",
    "3224": "立即创建",
    "3225": "图片未找到",
    "3226": "输入的字符不能超过{} 个！",
    "3227": "请输入系统通知信息",
    "3228": "输入的字符不能超过{}个！",
    "3229": "请输入有效期",
    "3230": "链接不能为空",
    "3231": "请输入卡片标题",
    "3232": "输入的字符不能超过200 个！",
    "3233": "请输入卡片内容",
    "3234": "活动类型下需要上传推广图片",
    "3235": "接收人设置（必选项）",
    "3236": "按用户推送",
    "3237": "用户姓名",
    "3238": "用户手机号",
    "3239": "添加一行",
    "3240": "批量导入",
    "3241": "按终端推送",
    "3242": "终端",
    "3243": "导入失败，请上传符合模板的Excel文件（xls、xlsx）",
    "3244": "当前文件过大，请上传4M以内的文件，格式包括xls、xlsx",
    "3245": "重新上传",
    "3246": "注销账号操作不可逆，请谨慎操作！",
    "3247": "永久注销当前账号，注销成功后该账号将无法使用，账号下的所有数据将被删除",
    "3248": "你正在申请注销当前账号。注销后，你将退出",
    "3249": "「荣大相关系列产品」且不能登录，如有付费产品也将一并取消，",
    "3250": "该账号将无法使用且无法恢复，账号下的所有数据也将被删除。确定要继续注销操作吗？",
    "3251": "注销前，请先移交或删除组织",
    "3252": "移交",
    "3253": "暂不注销",
    "3254": "继续注销",
    "3255": "已付费",
    "3256": "已到期",
    "3257": "账号注销成功",
    "3258": "账号注销失败",
    "3259": "移交项目",
    "3260": "删除项目",
    "3261": "删除项目后将无法恢复，请谨慎操作",
    "3262": "退出项目",
    "3263": "退出后将无法查看团队内容",
    "3264": "搜索目录",
    "3265": "文件名已存在，新文件将以{}进行命名",
    "3266": "确定要删除底稿目录吗？",
    "3267": "当前目录下的所有内容将被删除且无法恢复，确定要继续删除吗？",
    "3268": "全部下底稿上传不允许新建文件夹",
    "3269": "新建成功",
    "3270": "信息加载失败，请点击按钮重新加载",
    "3271": "搜索部门",
    "3272": "搜索职务",
    "3273": "手机号码",
    "3274": "电话",
    "3275": "新建客户联系人",
    "3276": "股东信息",
    "3277": "合作记录",
    "3278": "客户文档",
    "3279": "新增机构",
    "3280": "搜索机构编码/机构名称/机构简称",
    "3281": "新增中介机构",
    "3282": "机构信息",
    "3283": "请输入机构名称",
    "3284": "请输入机构简称",
    "3285": "请选择机构类型",
    "3286": "请输入机构联系人",
    "3287": "请输入客户负责人",
    "3288": "请输入联系电话",
    "3289": "传真",
    "3290": "请输入传真",
    "3291": "邮编",
    "3292": "请输入邮编",
    "3293": "办公地址",
    "3294": "请输入办公地址",
    "3295": "机构网址",
    "3296": "请输入机构网址",
    "3297": "机构简介",
    "3298": "请输入机构简介",
    "3299": "确定删除这条信息吗",
    "3300": "请输入机构编码,多个请用空格隔开",
    "3301": "请输入机构名称,多个请用空格隔开",
    "3302": "请输入机构简称,多个请用空格隔开",
    "3303": "请选择客户负责人",
    "3304": "请选择客户创建人",
    "3305": "机构名称内容不能为空",
    "3306": "机构简称内容不能为空",
    "3307": "机构类型内容不能为空",
    "3308": "机构联系人内容不能为空",
    "3309": "客户负责人内容不能为空",
    "3310": "联系电话内容不能为空",
    "3311": "邮箱格式错误",
    "3312": "传真有误，请重填",
    "3313": "我的企业客户",
    "3314": "搜索客户编码/客户名称",
    "3315": "行业(1级)",
    "3316": "行业(2级)",
    "3317": "行业(3级)",
    "3318": "行业(4级)",
    "3319": "新增企业客户",
    "3320": "请输入客户名称",
    "3321": "客户简称",
    "3322": "请输入客户简称",
    "3323": "上级客户",
    "3324": "请输入客户编码搜索",
    "3325": "客户地区",
    "3326": "请选择客户状态",
    "3327": "选择上市板块",
    "3328": "上市时间",
    "3329": "请输入法人代表",
    "3330": "请输入注册资本",
    "3331": "公司网址",
    "3332": "请输入公司网址",
    "3333": "公司简介",
    "3334": "请输入公司简介",
    "3335": "经营范围",
    "3336": "请输入经营范围",
    "3337": "请输入地址",
    "3338": "企业客户重名提示",
    "3339": "当前已存在{}个名称为{}的企业客户，客户创建人为{}",
    "3340": "是否创建同名新客户？客户编码将作为该客户唯一标识",
    "3341": "创建新客户",
    "3342": "请输入客户编码,多个请用空格隔开",
    "3343": "客户名称内容不能为空",
    "3344": "我的自然人客户",
    "3345": "新增自然人客户",
    "3346": "客户中文名：",
    "3347": "客户英文名：",
    "3348": "上级客户：",
    "3349": "客户地区：",
    "3350": "客户国籍：",
    "3351": "请选择客户国籍",
    "3352": "请选择客户学历",
    "3353": "客户性别：",
    "3354": "出生日期：",
    "3355": "身份证号码：",
    "3356": "请输入身份证号码",
    "3357": "客户状态：",
    "3358": "自然人重名提示",
    "3359": "硕士",
    "3360": "博士",
    "3361": "埃及",
    "3362": "爱尔兰",
    "3363": "奥地利",
    "3364": "澳大利亚",
    "3365": "巴西",
    "3366": "波兰",
    "3367": "德国",
    "3368": "俄国",
    "3369": "法国",
    "3370": "芬兰",
    "3371": "韩国",
    "3372": "荷兰",
    "3373": "加拿大",
    "3374": "美国",
    "3375": "尼日利亚",
    "3376": "挪威",
    "3377": "葡萄牙",
    "3378": "日本",
    "3379": "瑞国",
    "3380": "瑞士",
    "3381": "苏格兰",
    "3382": "泰国",
    "3383": "威尔士",
    "3384": "西班牙",
    "3385": "希腊",
    "3386": "新西兰",
    "3387": "以色列",
    "3388": "意大利",
    "3389": "印度",
    "3390": "英国",
    "3391": "客户中文名内容不能为空",
    "3392": "客户性别为必选",
    "3393": "客户出生日期不能为空",
    "3394": "客户身份证号错误",
    "3395": "客户类型内容不能为空",
    "3396": "联系电话不能为空",
    "3397": "客户状态内容不能为空",
    "3398": "原讨论文件都已删除",
    "3399": "请输入文件/文件夹名称",
    "3400": "位置",
    "3401": "删除人",
    "3402": "文件夹不支持预览",
    "3403": "确定要清空回收站吗？",
    "3404": "回收站清空后，文件将无法恢复，确定要清空吗？",
    "3405": "清空回收站成功！",
    "3406": "确定要还原文件吗？",
    "3407": "批量删除",
    "3408": "确定要彻底删除文件吗？",
    "3409": "讨论的文件已更换目录位置，请回到合集中选择单文件的定位",
    "3410": "成员管理",
    "3411": "已修改的内容尚未保存，确定退出吗",
    "3412": "文件已删除",
    "3413": "搜索客户名称",
    "3414": "拜访日期",
    "3415": "请输入拜访地点,多个请用空格隔开",
    "3416": "点击选择拜访人员",
    "3417": "请输入拜访形式,多个请用空格隔开",
    "3418": "请输入主要成果,多个请用空格隔开",
    "3419": "沟通让工作更高效",
    "3420": "群设置",
    "3421": "设置",
    "3422": "举报",
    "3423": "查询失败，请稍后重试！",
    "3424": "该公告已被{} 于{}年{}月{}日{}时删除！",
    "3425": "超过 20M 的图片请通过文件发送！",
    "3426": "请输入消息",
    "3427": "最多可输入{}个字符",
    "3428": "换行",
    "3429": "自动回复",
    "3430": "超出输入限制！",
    "3431": "Enter发送，Ctrl+Enter换行",
    "3432": "图片处理失败，请重新上传或使用文件方式发送！",
    "3433": "添加自定义",
    "3434": "添加自定义回复",
    "3435": "请输入自定义内容",
    "3436": "消息内容不能为空",
    "3437": "@成员",
    "3438": "截图",
    "3439": "「消息内文件」支持多人编辑啦！！",
    "3440": "上传文件后，点击多人编辑，即可实现多人实时协作，文件实时自动保存，快去试试吧！",
    "3441": "赞",
    "3442": "表情来源：",
    "3443": "屏幕截图",
    "3444": "截图并隐藏系统窗口",
    "3445": "当前已选择文件数",
    "3446": "文件已被撤回",
    "3447": "请输入群名称",
    "3448": "群组名最多输入50个字符",
    "3449": "群组名仅支持输入英文、汉字、数字",
    "3450": "被邀请人通过链接登录/注册后加入项目",
    "3451": "【荣大智慧云】",
    "3452": "“{}”邀请您加入项目“{}”,点击下方链接即可加入",
    "3453": "输入/粘贴手机号，多个可通过换行进行分隔，如",
    "3454": "切换",
    "3455": "目录视图",
    "3456": "个结果,第",
    "3457": "小提示",
    "3458": "如需针对单个目录进行审批操作，可将筛选项中的目录状态选为待审批后点击查询，即可对单个目录进行审批操作",
    "3459": "注：目录审批搜索结果页不会联动选中目录",
    "3460": "主工作台-我的审批-审批记录",
    "3461": "请选择审批人",
    "3462": "审批部门",
    "3463": "请选择审批部门",
    "3464": "请输入审批意见关键字",
    "3465": "节点审批结果",
    "3466": "所在位置",
    "3467": "审批人部门",
    "3468": "当前无选中文件，请选择您要导出的文件",
    "3469": "搜索项目名称{}申请内容",
    "3470": "暂无权限查看该页面",
    "3471": "提醒您尽快审批{}发起的{}，可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "3472": "新增自然人",
    "3473": "搜索会议主题",
    "3474": "请输入会议类型",
    "3475": "选择导出项",
    "3476": "确定要删除该会议吗？",
    "3477": "删除成功!",
    "3478": "{}会议已被关联，不能删除",
    "3479": "不能删除",
    "3480": "确定删除所有会议？",
    "3481": "已选日志类型",
    "3482": "日志标题（可编辑）",
    "3483": "抄送人（必选）",
    "3484": "项目组成员",
    "3485": "提交日志",
    "3486": "编辑日志",
    "3487": "标题最大长度{}个字",
    "3488": "日志内容不能为空",
    "3489": "日志内容最大长度{}个字",
    "3490": "抄送人不能为空",
    "3491": "提交成功",
    "3492": "发送到人",
    "3493": "搜索日志标题",
    "3494": "与我相关",
    "3495": "我发出的",
    "3496": "暂无日志",
    "3497": "复用这篇日志模板",
    "3498": "分享",
    "3499": "分享这篇日志",
    "3500": "导出附件",
    "3501": "导出到项目文档",
    "3502": "日志修改记录",
    "3503": "暂无修改记录",
    "3504": "新增抄送人",
    "3505": "已经到底啦",
    "3506": "分享日志",
    "3507": "通讯录/我的日志",
    "3508": "工作台/我的日志",
    "3509": "评论{}的日志，可@组织成员，最多可输入{}个字",
    "3510": "确认要把文件放入回删除吗?",
    "3511": "可@组织成员，最多可输入{}个字",
    "3512": "请输入评论内容",
    "3513": "请输入回复内容",
    "3514": "修改日志",
    "3515": "临时草稿自动保存成功",
    "3516": "已自动同步未完成的草稿内容",
    "3517": "确定要引用远程草稿吗？",
    "3518": "检测到您有远程草稿，引用后，将直接使用远程草稿的内容，确定要引用吗？",
    "3519": "创建成功",
    "3520": "抄送人/组织/部门：{} 等{}个无效，已自动移除",
    "3521": "抄送人/组织/部门：{} 无效，已自动移除",
    "3522": "投票截止时间",
    "3523": "我参与的",
    "3524": "起：",
    "3525": "止：",
    "3526": "投票状态",
    "3527": "决策",
    "3528": "项目描述:",
    "3529": "投票编辑",
    "3530": "投票正在进行中不能删除",
    "3531": "确定删除所有选中投票",
    "3532": "请选择要删除选项",
    "3533": "确定删除已勾选投票？",
    "3534": "{}投票已被关联，不能删除",
    "3535": "项目信息（必填）",
    "3536": "（注：项目从属于组织）",
    "3537": "点击选择所属部门",
    "3538": "填写更多内容",
    "3539": "项目信息（选填）",
    "3540": "请输入项目简称",
    "3541": "上级项目",
    "3542": "请输入项目ID搜索",
    "3543": "请选择关联项目",
    "3544": "请选择项目地区",
    "3545": "开始阶段",
    "3546": "请选择开始阶段",
    "3547": "结束阶段",
    "3548": "请先选择业务类型和开始阶段",
    "3549": "请选择结束阶段",
    "3550": "计划开始时间",
    "3551": "计划结束时间",
    "3552": "标签信息（配置）",
    "3553": "引用标签",
    "3554": "完成创建",
    "3555": "温馨提示：",
    "3556": "智慧云用户将直接加入项目",
    "3557": "新用户将收到邀请加入短信",
    "3558": "请选组织名称",
    "3559": "请选择所属部门",
    "3560": "创建商机项目重复，是否继续创建?",
    "3561": "继续",
    "3562": "创建成功！",
    "3563": "新建组织",
    "3564": "填写更多信息（可选）",
    "3565": "智慧云用户将会直接加入项目，新用户将会收到邀请加入短信",
    "3566": "搜索审批流程名称",
    "3567": "新增标签",
    "3568": "字段名称、选项内容不能为空",
    "3569": "标签权限配置",
    "3570": "新增分类",
    "3571": "请输入分类名称（100字以内）",
    "3572": "编辑分类",
    "3573": "删除分类",
    "3574": "标签名称",
    "3575": "标签类型",
    "3576": "选项内容",
    "3577": "分类名称：",
    "3578": "该分类名称已存在，请重新填写",
    "3579": "编辑内容未保存，请保存后再进行其他操作",
    "3580": "该标签信息已被引用，不可删除",
    "3581": "确定要删除该标签分类吗？",
    "3582": "删除后，分类下的标签会一同删除，确定要继续操作吗？",
    "3583": "标签名称：",
    "3584": "请输入标签名称",
    "3585": "标签类型：",
    "3586": "选项内容：",
    "3587": "添加",
    "3588": "新增字段",
    "3589": "删除字段",
    "3590": "文本",
    "3591": "下拉列表",
    "3592": "数值",
    "3593": "不支持的类型",
    "3594": "勾选内容已被引用，不可删除",
    "3595": "输入角色名称进行搜索",
    "3596": "可编辑标签",
    "3597": "选择标签分类",
    "3598": "输入分类名称进行搜索",
    "3599": "已选标签分类",
    "3600": "您删除的内容已被项目应用，删除后不可恢复是否继续",
    "3601": "选择的标签分类不存在，请重新选择！",
    "3602": "当前归档阶段",
    "3603": "历史归档阶段",
    "3604": "当前归档时间",
    "3605": "当前归档人员",
    "3606": "借阅",
    "3607": "借阅人员",
    "3608": "请输入借阅人员",
    "3609": "借阅时长",
    "3610": "借阅内容",
    "3611": "查看全部文件",
    "3612": "确定要取消文件借阅吗？",
    "3613": "已填写的内容尚未提交，当前操作将清空所有内容，确定要继续操作吗？",
    "3614": "提醒您尽快审批关于{}，项目的底稿借阅审批,可在'我的审批-待我审批'中进行查看，该审批提交时间为 {}",
    "3615": "从借阅成功起，借阅时限为{}小时，超过时限后，借阅文件将自动失效",
    "3616": "恢复项目",
    "3617": "恢复项目成功！",
    "3618": "终止原因",
    "3619": "请输入终止原因",
    "3620": "终止时间",
    "3621": "请选择终止日期",
    "3622": "终止说明",
    "3623": "导出组织内您可查看项目的人员信息，以Excel表格格式导出。",
    "3624": "会议发起成功",
    "3625": "是否要将该成员移出项目组？",
    "3626": "(移出项目后，被移出人员所上锁的文件将会解锁)",
    "3627": "加入时间",
    "3628": "邀请人",
    "3629": "已加入{}",
    "3630": "邀请中{}",
    "3631": "申请中{}",
    "3632": "搜索姓名",
    "3633": "角色：",
    "3634": "加入时间：",
    "3635": "离开时间：",
    "3636": "请先选择数据文件",
    "3637": "请选择项目中成员",
    "3638": "成员角色",
    "3639": "角色名称",
    "3640": "编辑角色",
    "3641": "上传文件/新版本",
    "3642": "文件复制",
    "3643": "文件剪切",
    "3644": "文件删除",
    "3645": "文件锁定",
    "3646": "角色名称不能为空",
    "3647": "保存!",
    "3648": "确定要删除该角色吗？",
    "3649": "删除该角色后，添加成员时将无法再选择该角色，确定要继续删除吗？",
    "3650": "修改成功!",
    "3651": "结果",
    "3652": "确定要删除选中的投票结果吗？",
    "3653": "确定删除所有选中投票？",
    "3654": "项目移交",
    "3655": "项目删除",
    "3656": "项目退出",
    "3657": "标签信息",
    "3658": "引用",
    "3659": "选择客户",
    "3660": "导入中",
    "3661": "发行档案",
    "3662": "导入",
    "3663": "下载模板",
    "3664": "发行人联系人",
    "3665": "发行人联系方式",
    "3666": "项目组联系人",
    "3667": "项目组联系方式",
    "3668": "主体资质",
    "3669": "债项资质",
    "3670": "申报规模{}亿{}",
    "3671": "核准规模{}亿{}",
    "3672": "批文有效期",
    "3673": "批复文号",
    "3674": "发行方式",
    "3675": "发行场地",
    "3676": "债券期限",
    "3677": "担保机构",
    "3678": "特殊条款",
    "3679": "往期债券",
    "3680": "承销团成员",
    "3681": "簿记室",
    "3682": "启动发行后填写",
    "3683": "债券简称",
    "3684": "银行间代码",
    "3685": "是否分期",
    "3686": "是否多品种发行",
    "3687": "已发行规模",
    "3688": "交易所代码",
    "3689": "本期债券规模（亿）",
    "3690": "质押代码",
    "3691": "询价利率区间{}%{}",
    "3692": "发行后剩余规模{}亿{}",
    "3693": "最终发行利率{}%{}",
    "3694": "受托期限",
    "3695": "参会委员",
    "3696": "时间类信息",
    "3697": "添加时间字段",
    "3698": "已被任务引用，不可编辑",
    "3699": "发行成功后填写",
    "3700": "是否为受托管理人",
    "3701": "抄送方式{}审批通过后通知",
    "3702": "请输入申请内容{}最多输入200字",
    "3703": "人员选择",
    "3704": "请输入登录密码",
    "3705": "移交创建人角色",
    "3706": "移交后退出项目并解锁上锁文件",
    "3707": "任务移交至新设创建人",
    "3708": "当前项目",
    "3709": "点击退出项目后，由您上锁的文件将会自动解锁",
    "3710": "请确认登录密码",
    "3711": "退出",
    "3712": "是否确认删除该项目",
    "3713": "利益冲突核查报告列表",
    "3714": "查看报告",
    "3715": "利益冲突比对结果报告",
    "3716": "项目发行信息档案导入",
    "3717": "共{}个导入项，其中{}个可成功导入",
    "3718": "发现以下{}个导入项不符合导入要求，将不会被导入",
    "3719": "导入项",
    "3720": "错误原因",
    "3721": "确定导入",
    "3722": "确定要导入发行档案信息吗",
    "3723": "导入信息后，当前信息将会被覆盖，确定要继续导入吗？",
    "3724": "赵达",
    "3725": "您没有权限查看该项目信息",
    "3726": "项目编码不能为空",
    "3727": "项目名称不能为空",
    "3728": "结束日期不能早于开始日期",
    "3729": "所属部门不能为空",
    "3730": "确定要删除项目吗?",
    "3731": "项目删除成功！",
    "3732": "密码错误",
    "3733": "移交创建人角色不能为空",
    "3734": "您当前为项目创建人，请先移交项目",
    "3735": "该成员不在项目中",
    "3736": "当前无审批通过的底稿文件可归档",
    "3737": "确定要选择客户吗？",
    "3738": "选择客户后将无法进行变更，确定继续操作吗？",
    "3739": "银行间代码不能超出20位数字，请修改。",
    "3740": "交易所代码不能超出20位数字，请修改。",
    "3741": "质押代码不能超出20位数字，请修改。",
    "3742": "询价利率区间格式不正确，请修改。",
    "3743": "批文有效期开始时间不能大于结束时间",
    "3744": "不能存在相同的时间字段，请修改",
    "3745": "文件类型不匹配",
    "3746": "请选择时间变量",
    "3747": "剩余一个时间变量项时不可删除",
    "3748": "以内的Excel导入(xls,xlsx)；",
    "3749": "第一列",
    "3750": "为任务标题，不能超过180字；",
    "3751": "单次",
    "3752": "最高支持导入",
    "3753": "条数据，超过 1000条的部分忽略不计；",
    "3754": "导入任务均为一级任务，不展示父子任务关系。",
    "3755": "导入任务",
    "3756": "正在识别中，请稍后...",
    "3757": "请选择导入阶段:",
    "3758": "可导入{}个，识别失败{}个",
    "3759": "注:1.如未处理识别失败的任务，失败任务将不会建立；2.如操作栏下关闭的任务将不会建立。",
    "3760": "创建任务",
    "3761": "上一个失败任务",
    "3762": "下一个失败任务",
    "3763": "未识别到任务名称，请检查本地文件",
    "3764": "请上传 4M 以内的Excel文件（xls、xlsx）。",
    "3765": "任务建立失败，请在操作栏下开启任务",
    "3766": "建立任务成功",
    "3767": "是否取消建立任务，确认后将不会建立任务。",
    "3768": "查看更多父级",
    "3769": "所属任务",
    "3770": "确定要删除该条消息吗？",
    "3771": "通知发行人或客户（适用于外部人员）",
    "3772": "请输入子任务名称，按回车键完成",
    "3773": "请输入子任务名称",
    "3774": "编辑任务",
    "3775": "收起设置",
    "3776": "任务设置",
    "3777": "新建任务",
    "3778": "当前内容已变更，是否保存修改？",
    "3779": "最大可同时打开10个任务选项卡，是否关闭其他选项卡",
    "3780": "注意事项",
    "3781": "请输入任务标题（必填）",
    "3782": "任务内容",
    "3783": "任务产出",
    "3784": "工时统计",
    "3785": "任务动态",
    "3786": "文件会上传到任务产出中",
    "3787": "任务完成",
    "3788": "请输入任务标题",
    "3789": "任务基本信息未保存，请保存后继续该操作",
    "3790": "确定要{}任务",
    "3791": "有项目时间信息不完整，是否完善?",
    "3792": "全部动态",
    "3793": "日常沟通({})",
    "3794": "任务日志",
    "3795": "正式回复({})",
    "3796": "不能重复选择",
    "3797": "搜索添加执行人",
    "3798": "搜索添加抄送人",
    "3799": "添加任务标签",
    "3800": "请选择时间变量（仅对债类业务有效）",
    "3801": "任务提醒",
    "3802": "请选择自定义时间",
    "3803": "每个月第{}天",
    "3804": "每个{}月第{}天",
    "3805": "每个月第{}个星期{}",
    "3806": "每个{}月第{}个星期{}",
    "3807": "每年{}",
    "3808": "每{}年",
    "3809": "到",
    "3810": "重复{}次",
    "3811": "每月第{}个",
    "3812": "每年{}{}日",
    "3813": "每周星期{}",
    "3814": "每月第{}星期{}",
    "3815": "每年{}日",
    "3816": "每{}天",
    "3817": "星期{}",
    "3818": "每周{}",
    "3819": "每{}周{}",
    "3820": "每月第{}天",
    "3821": "每{}月第{}天",
    "3822": "每月第x天",
    "3823": "每{}月第x天",
    "3824": "每月第{}个星期{}",
    "3825": "每{}月第{}个星期{}",
    "3826": "每月第x个星期第x天",
    "3827": "每{}月第x个星期第x天",
    "3828": "请输入内容，可@任务成员，最多可输入{}字",
    "3829": "超出{}字输入限制",
    "3830": "自定义周期",
    "3831": "重复频率",
    "3832": "重复时间",
    "3833": "无限重复",
    "3834": "终止于某天",
    "3835": "选择日期时间",
    "3836": "限定重复次数",
    "3837": "次后",
    "3838": "天",
    "3839": "个月",
    "3840": "请选择重复时间",
    "3841": "每{}天到{}结束",
    "3842": "每{}天，重复{}次",
    "3843": "星期{},",
    "3844": "每{}周的{}",
    "3845": "每{}周的{}{}结束",
    "3846": "每{}周的{}，重复{}次",
    "3847": "每{}月的第{}天",
    "3848": "每{}月的第{}天到{}结束",
    "3849": "每{}月的第{}天,重复{}次",
    "3850": "每{}月",
    "3851": "到{}结束",
    "3852": "每{}年,重复{}次",
    "3853": "完成任务",
    "3854": "完成任务(所有人)",
    "3855": "取消完成(所有人)",
    "3856": "你修改了任务名称，是否同步修改任务文件夹名称？",
    "3857": "文件夹名称重复时，自动重命名",
    "3858": "文件夹名称重复时，中止保存",
    "3859": "设置计划工时",
    "3860": "填报实际工时",
    "3861": "计划任务工时",
    "3862": "实际任务工时",
    "3863": "禁止更新他人工时",
    "3864": "计划工时/小时",
    "3865": "实际工时/小时",
    "3866": "填写本次新增工时",
    "3867": "将离开工时统计页面，已填写工时尚未保存，是否保存修改？",
    "3868": "不保存",
    "3869": "工时调整不可超过当前实际工时",
    "3870": "选择导入任务",
    "3871": "当前业务类型下的模板",
    "3872": "已选任务数量:",
    "3873": "确认导入",
    "3874": "该业务类型未配置任务模板",
    "3875": "请尝试以下两种操作",
    "3876": "导入Excel模板",
    "3877": "前往配置任务模板",
    "3878": "请联系管理员为该业务类型配置任务模板",
    "3879": "请先选择任务",
    "3880": "弹窗关闭",
    "3881": "暂无相关任务数据",
    "3882": "未添加执行人",
    "3883": "未添加抄送人",
    "3884": "未选择时间",
    "3885": "未添加标签",
    "3886": "未填写无任务内容",
    "3887": "未填写注意事项",
    "3888": "正式回复",
    "3889": "查看全部回复内容",
    "3890": "正在加载中......",
    "3891": "任务产出-文件",
    "3892": "暂不支持在浏览器中下载文件夹，请通过PC客户端下载",
    "3893": "确定要取消关联吗？",
    "3894": "取消关联后，该文件将从「任务产出」中移除，确定要取消关联码？",
    "3895": "取消关联成功",
    "3896": "全部完成",
    "3897": "批量编辑任务",
    "3898": "自定义时间",
    "3899": "重复周期",
    "3900": "添加子任务",
    "3901": "每年{}月{}日",
    "3902": "每{}年{}",
    "3903": "是否打开",
    "3904": "是否继续?",
    "3905": "已取消关闭",
    "3906": "请填写完整的时间",
    "3907": "是否保存任务基本信息并继续当前操作？是否继续?",
    "3908": "请输入任务名称",
    "3909": "确定要删除该{}吗, 是否继续?",
    "3910": "取消输入",
    "3911": "确定要关闭该{}吗, 是否继续?",
    "3912": "确定要删除该任务吗, 是否继续?",
    "3913": "确定要关闭该任务吗, 是否继续?",
    "3914": "关闭成功!",
    "3915": "全部编辑成功",
    "3916": "{}个任务编辑成功，{}个任务编辑失败",
    "3917": "可拖拽文件上传",
    "3918": "选中的文件取消关联后，将从「参考文件」中移除，确定要取消关联吗？",
    "3919": "取消关联后，该文件将从「参考文件」中移除，确定要取消关联吗？",
    "3920": "选择阶段导入",
    "3921": "新模板以增量的方式覆盖之前的模板, 是否继续?",
    "3922": "任务模板预览",
    "3923": "确认配置",
    "3924": "新导入任务“更新《{}》”与原有模板任务重名！",
    "3925": "新导入任务“更新",
    "3926": "”与原有模板任务重名！",
    "3927": "自动重命名",
    "3928": "跳过这个任务",
    "3929": "后续同名任务是否按此规则执行",
    "3930": "添加调查工具",
    "3931": "新增调查工具",
    "3932": "工具链接",
    "3933": "编辑调查工具",
    "3934": "确定要删除吗？",
    "3935": "已有标签",
    "3936": "暂无标签",
    "3937": "标签字数不超过{}个字，按回车保存",
    "3938": "选择标签颜色",
    "3939": "请给标签选择一个颜色",
    "3940": "修改记录",
    "3941": "请输入标签,标签字数不超过{}个字，按回车保存",
    "3942": "请输入标签,标签字数不超过{}个字",
    "3943": "任务数量",
    "3944": "包含不可见任务",
    "3945": "个任务",
    "3946": "最新修改人",
    "3947": "最新修改时间",
    "3948": "确定要删除该标签吗？",
    "3949": "标签被删除后，任务中引用的该标签将同时被删除，确定要继续删除吗？",
    "3950": "标签修改记录",
    "3951": "操作内容",
    "3952": "将本列表所有任务删除",
    "3953": "取消完成任务",
    "3954": "所属父任务",
    "3955": "确定要删除任务{}",
    "3956": "批量操作",
    "3957": "添加任务",
    "3958": "确定要{}所有选中的任务吗？",
    "3959": "已打开的任务",
    "3960": "关闭所有任务",
    "3961": "显示侧边栏",
    "3962": "自定义侧边栏",
    "3963": "对扩展工具栏是否满意",
    "3964": "感谢你的反馈",
    "3965": "发送反馈",
    "3966": "请告诉我们不满意的原因",
    "3967": "请对您的问题类型进行详细描述",
    "3968": "好的，感谢你的反馈！我们将尽快做出优化计划",
    "3969": "是什么原因",
    "3970": "请输入{}名称",
    "3971": "修改日期",
    "3972": "输入要搜索的目录",
    "3973": "目录名称",
    "3974": "增加子目录",
    "3975": "子目录名称",
    "3976": "请输入目录名称",
    "3977": "删除后，将删除该目录下的所有子目录,是否确认删除？",
    "3978": "请输入注意事项,最多输入200字",
    "3979": "输入内容不能为空",
    "3980": "目录列表",
    "3981": "搜索目录名称",
    "3982": "下载目录模板",
    "3983": "新增目录",
    "3984": "权限设置",
    "3985": "权限配置",
    "3986": "目录名称：",
    "3987": "所属业务类型：",
    "3988": "备注信息：",
    "3989": "请输入备注信息",
    "3990": "目录文件：",
    "3991": "注：1、请上传纯目录的word文件或符合要求的excel文件，上传目录文件后，系统将自动解析生产目录；",
    "3992": "2、如果您的目录模板含有特殊字符，引用前台时系统会自动帮您替换为空格或下划线；",
    "3993": "请先选择数据",
    "3994": "请先复制目录",
    "3995": "仅含项目阶段的业务类型可进行粘贴",
    "3996": "目录支持上传以下格式的文件：DOC、DOCX、XLS、XLSX，请重新上传正确格式的文件后重试",
    "3997": "该文件中未检测到目录信息",
    "3998": "操作过于频繁",
    "3999": "请上传纯目录的word文件或符合要求的excel文件",
    "4000": "已设置窗口正常大小",
    "4001": "已设置窗口最大化",
    "4002": "多窗体模式已开启",
    "4003": "当打开了一个或多个独立窗体时，你可以将不同项目之间的任何文件进行自由拖动",
    "4004": "提示：",
    "4005": "从当前项目文档或底稿视图向不同项目的窗体拖动文件时，操作结果做复制粘贴处理",
    "4006": "在开启消息独立窗口时，可以将当前列表中的文件直接拖拽至会话中",
    "4007": "数据权限范围",
    "4008": "组织内成员",
    "4009": "已选部门/成员",
    "4010": "所在部门成员个人日志",
    "4011": "指定部门/成员个人日志",
    "4012": "组织全部成员个人日志",
    "4013": "下列部门/成员不存在，已从「已选列表」中自动移除",
    "4014": "审批类型名称",
    "4015": "类型名称",
    "4016": "荣大科技",
    "4017": "是否确定删除？",
    "4018": "已经是第一条",
    "4019": "已经最后第一条",
    "4020": "请填写审批类型名称",
    "4021": "{}该审批类型，将同步{}该审批类型下的所有流程, 是否继续?",
    "4022": "添加配置",
    "4023": "借阅权限",
    "4024": "请输入时间",
    "4025": "当前时间不能删除",
    "4026": "借阅时间未配置，请进行配置",
    "4027": "时间不能为空",
    "4028": "当前输入的时间已存在",
    "4029": "添加类型",
    "4030": "会议类型配置",
    "4031": "投票类型配置",
    "4032": "请输入类型名称",
    "4033": "人数限制",
    "4034": "人员限制",
    "4035": "类型说明",
    "4036": "人,",
    "4037": "投票规则",
    "4038": "大于等于",
    "4039": "人同意允许通过",
    "4040": "人有条件通过为有条件通过",
    "4041": "人不同意不通过",
    "4042": "人暂缓表决为暂缓表决",
    "4043": "请输入人数",
    "4044": "人参加才能发起",
    "4045": "添加限制人员",
    "4046": "请输入类型说明",
    "4047": "同意（必选）",
    "4048": "不同意（必选）",
    "4049": "的人",
    "4050": "注：有条件通过默认为通过暂缓表决默认为不通过",
    "4051": "例：（2/3）的人大于等于同意允许通过",
    "4052": "例：有条件通过允许通过",
    "4053": "例：不同意为不通过",
    "4054": "例：暂缓表决为不通过",
    "4055": "例：（2/3）有条件通过允许通过",
    "4056": "例：（2/3）不同意为不通过",
    "4057": "例：（2/3）暂缓表决为不通过",
    "4058": "该角色已存在",
    "4059": "会议类型名称不能为空",
    "4060": "人员限制不能为空",
    "4061": "人数限制小于人员限制人数总和",
    "4062": "确定删除所选会议",
    "4063": "投票类型名称不能为空",
    "4064": "人数限制不能为空",
    "4065": "投票规则值不能为空",
    "4066": "投票规则最大值不能小于最小值",
    "4067": "确定删除所选投票",
    "4068": "通知方式配置",
    "4069": "短信通知",
    "4070": "启用短信通知",
    "4071": "注：启用前请确保系统已调试成功。",
    "4072": "邮件通知",
    "4073": "启用邮件通知",
    "4074": "保存失败",
    "4075": "获取失败",
    "4076": "业务类型名称",
    "4077": "退出编辑",
    "4078": "下载模版",
    "4079": "项目阶段名称",
    "4080": "请输入类型名称（50字以内）",
    "4081": "确定要导入业务类型吗?",
    "4082": "只能导入xls、xlsx格式文件",
    "4083": "导入成功！",
    "4084": "{}个阶段导入失败，阶段名称不可重复。",
    "4085": "{}个阶段导入失败，阶段名称不支持输入特殊字符。",
    "4086": "请填写阶段名称",
    "4087": "暂无数据可编辑",
    "4088": "成功修改",
    "4089": "{}该业务类型，将同步{}该业务类型下的所有流程和模板, 是否继续?",
    "4090": "角色基本信息",
    "4091": "修改项目角色",
    "4092": "选中角色已复制，请选择需要粘贴的角色",
    "4093": "确定删除选中的角色",
    "4094": "任务配置搜索结果",
    "4095": "新增任务模板",
    "4096": "模板名称",
    "4097": "包含以下全部关键字{}以空格区分{}",
    "4098": "请选择创建人",
    "4099": "新建任务模板",
    "4100": "任务模板名称",
    "4101": "注：如果您的任务模板含有特殊字符情况，引用前台时系统会自动帮您替换为空格或下划线处理；",
    "4102": "项目阶段类型",
    "4103": "任务模板名称：",
    "4104": "选择业务类型：",
    "4105": "请输入任务模板名称",
    "4106": "存在同名模板是否确定继续保存",
    "4107": "编辑任务模板",
    "4108": "此操作将永久删除该模板, 是否继续?",
    "4109": "任务导出",
    "4110": "是否保存已编辑内容",
    "4111": "暂无模板导出",
    "4112": "{}, 是否继续?",
    "4113": "导入后的阶段任务模板将会覆盖当前阶段模板，是否导入?",
    "4114": "请导入从系统中下载的模板！",
    "4115": "此操作将永久删除该任务, 是否继续?",
    "4116": "时间变量名称",
    "4117": "请输入时间变量名称",
    "4118": "查询结果为空",
    "4119": "添加时间变量",
    "4120": "编辑时间变量",
    "4121": "请先将时间规则禁用后删除",
    "4122": "是否要删除?",
    "4123": "启用成功！",
    "4124": "新增配置",
    "4125": "暂无权限查看，如有需要请联系组织管理员",
    "4126": "规则名称",
    "4127": "包含以下关键字",
    "4128": "IP地址",
    "4129": "受控人员",
    "4130": "请输入人员姓名",
    "4131": "请选择操作用户",
    "4132": "IP安全配置",
    "4133": "公网IP地址",
    "4134": "受控人数",
    "4135": "停用",
    "4136": "人员编辑",
    "4137": "IP编辑",
    "4138": "IP监控日志",
    "4139": "您确定删除该IP吗?",
    "4140": "字段管理",
    "4141": "注：关闭后，该字段在表单中将取消必填。",
    "4142": "文件解锁信息",
    "4143": "于{}手动解锁{}项文件",
    "4144": "锁定信息",
    "4145": "于",
    "4146": "进行编辑",
    "4147": "试用申请已提交成功，专员将在2个工作日内联系您",
    "4148": "智能网查将在5-10分钟内自动开通，请注意查收短信或智慧云消息",
    "4149": "分享有礼",
    "4150": "二维码邀请",
    "4151": "活动规则",
    "4152": "同一手机号视为同一用户，不重复赠送活动奖品",
    "4153": "邀请好友成功后，系统会自动发放奖品到您的账户中，请注意查收。",
    "4154": "活动时间",
    "4155": "权益有效期：自权益开通之日起{}内有效，过期作废，不予补偿。",
    "4156": "一旦发现有人邀请数据作弊，将清除其邀请数据，取消其获奖资格。",
    "4157": "还没有邀请成功的好友哦~",
    "4158": "奖励",
    "4159": "二维码复制失败，将下载该图片",
    "4160": "邀请二维码",
    "4161": "请输入联系人姓名",
    "4162": "人员属性",
    "4163": "请选择人员属性",
    "4164": "新增客户联系人",
    "4165": "固话",
    "4166": "身份证号",
    "4167": "是否为董监高",
    "4168": "新建联系人",
    "4169": "部门：",
    "4170": "请输入固话",
    "4171": "请输入职务",
    "4172": "证件号码",
    "4173": "请输入证件号码",
    "4174": "请输入手机号码",
    "4175": "编辑客户联系人",
    "4176": "确定删除该联系人",
    "4177": "全部人员",
    "4178": "董监高",
    "4179": "联系人名称内容不能为空",
    "4180": "部门内容不能为空",
    "4181": "固定电话内容不能为空",
    "4182": "固定电话仅支持\"-\"和数字，长度为{}字。",
    "4183": "是否为董监高为必选",
    "4184": "证件号码格式不正确,请重新输入",
    "4185": "职务内容不能为空",
    "4186": "手机号码内容不能为空",
    "4187": "手机号格式不正确,请重新输入",
    "4188": "邮箱格式不正确,请重新输入",
    "4189": "固定电话不能为空",
    "4190": "证件号码错误",
    "4191": "手机号码不能为空",
    "4192": "手机号码有误，请重填",
    "4193": "请选择客户地区",
    "4194": "服务团队",
    "4195": "信息跟踪人",
    "4196": "请输入信息跟踪人",
    "4197": "资本注册",
    "4198": "张三",
    "4199": "请输入正确格式",
    "4200": "客户中文名",
    "4201": "客户英文名",
    "4202": "客户国籍",
    "4203": "客户性别",
    "4204": "出生日期",
    "4205": "身份证号码",
    "4206": "请输入身份证号",
    "4207": "客户出生日期内容不能为空",
    "4208": "股东名称",
    "4209": "请输入股东名称",
    "4210": "股东类型",
    "4211": "请选择股东类型",
    "4212": "新增股东信息",
    "4213": "持股数",
    "4214": "持股比例",
    "4215": "身份证号/信用代码",
    "4216": "股东姓名",
    "4217": "请输入股东姓名",
    "4218": "持股数量",
    "4219": "请输入持股数",
    "4220": "信用代码",
    "4221": "请输入统一社会信用代码",
    "4222": "请输入持股比例",
    "4223": "编辑股东信息",
    "4224": "变更记录",
    "4225": "股东",
    "4226": "变更前股权比例",
    "4227": "变更后股权比例",
    "4228": "股权变更日期",
    "4229": "身份证号：",
    "4230": "信用代码：",
    "4231": "股东类型内容不能为空",
    "4232": "股东姓名内容不能为空",
    "4233": "持股数量内容不能为空",
    "4234": "身份证号/统一社会信用代码不能为空",
    "4235": "身份证号错误",
    "4236": "持股比例内容不能为空",
    "4237": "请输入拜访人员",
    "4238": "新增拜访记录",
    "4239": "新建拜访记录",
    "4240": "拜访记录信息",
    "4241": "拜访创建人",
    "4242": "请输入拜访形式",
    "4243": "请输入拜访地点",
    "4244": "请输入主要成果",
    "4245": "保 存",
    "4246": "编辑拜访记录",
    "4247": "确定删除该拜访记录吗",
    "4248": "拜访创建人内容不能为空",
    "4249": "拜访人员内容不能为空",
    "4250": "拜访开始日期内容不能为空",
    "4251": "拜访结束日期内容不能为空",
    "4252": "拜访地点内容不能为空",
    "4253": "主要成果内容不能为空",
    "4254": "结束时间不能小于开始时间",
    "4255": "暂不支持使用",
    "4256": "此应用当前仅支持智慧云Windows客户端使用，请先下载客户端",
    "4257": "项目创建时间",
    "4258": "新建{}",
    "4259": "请选择要下载的文件",
    "4260": "文件夹不支持下载，请选择下载文件",
    "4261": "文件夹不支持版本查看",
    "4262": "请选择要删除的数据",
    "4263": "已有相同名称的文件夹，是否以 {} 命名文件夹",
    "4264": "该文件已解锁",
    "4265": "文件回收站",
    "4266": "请选择要还原的文件",
    "4267": "已经到根目录了",
    "4268": "还原路径",
    "4269": "部分对象的还原路径不存在，请选择还原路径",
    "4270": "共{}个结果, 第{}个",
    "4271": "不能包含特殊字符\\\\/:*?\"<>|",
    "4272": "已有相同名称的目录，是否以 {} 命名目录",
    "4273": "已取消重命名",
    "4274": "今天也辛苦啦",
    "4275": "智慧云陪你一起努力",
    "4276": "历史沟通记录",
    "4277": "进入组织",
    "4278": "已同意",
    "4279": "立即沟通",
    "4280": "好的，现在创建",
    "4281": "进入群聊",
    "4282": "定位到文件",
    "4283": "文件创建失败",
    "4284": "定位到文件夹",
    "4285": "欢迎来到智慧云！",
    "4286": "已拒绝",
    "4287": "立即评价",
    "4288": "查看订单",
    "4289": "支付订单",
    "4290": "去处理",
    "4291": "去审批",
    "4292": "已评价",
    "4293": "请到主窗口操作此功能!",
    "4294": "已失效",
    "4295": "你不在当前项目中，暂不能查看项目信息",
    "4296": "输入关键词进行搜索",
    "4297": "关键词",
    "4298": "请输入关键词进行搜索(空格区分)",
    "4299": "可操作",
    "4300": "消息类型",
    "4301": "点击选择消息类型",
    "4302": "没有与搜索结果的匹配项，请检查你的搜索选项",
    "4303": "群成员",
    "4304": "以下所有人",
    "4305": "编辑群公告",
    "4306": "设为置顶",
    "4307": "删除群公告",
    "4308": "群公告置顶成功！",
    "4309": "操作失败，请稍后再试！",
    "4310": "确定要删除该篇公告吗？",
    "4311": "群公告删除成功！",
    "4312": "新建群公告",
    "4313": "超出输入限制",
    "4314": "若要插入链接，请以：http:// 或者 https:// 开头",
    "4315": "超出最大字符长度，请检查！",
    "4316": "群公告更新成功！",
    "4317": "群公告创建成功！",
    "4318": "确定要离开当前页面吗？",
    "4319": "已输入的内容尚未发布，当前操作将清空所有内容，确定要继续操作吗？",
    "4320": "设为",
    "4321": "没有更多啦",
    "4322": "暂无群公告",
    "4323": "群公告适用于发布群规、活动等信息",
    "4324": "更新于",
    "4325": "对方已注销账号",
    "4326": "发送消息",
    "4327": "机器人",
    "4328": "@消息",
    "4329": "选择群成员",
    "4330": "无可下载文件",
    "4331": "暂无聊天记录",
    "4332": "未找到相关记录",
    "4333": "下载全部",
    "4334": "讨论文件合集{}项",
    "4335": "[该消息类型本版本暂不支持查看（如需了解消息内容，请直接联系发送人）]",
    "4336": "您已被踢出此群聊",
    "4337": "文件不存在",
    "4338": "您已退出当前会话群，无法继续访问！",
    "4339": "讨论文件合集中所有文件版本/文件夹内容将实时与文档中内容进行同步更新",
    "4340": "选中另存为",
    "4341": "全部另存为",
    "4342": "选中下载",
    "4343": "全部下载",
    "4344": "该文件类型暂不支持预览，是否下载到本地？",
    "4345": "讨论文件合集已被撤回",
    "4346": "项目/群名称",
    "4347": "归属组织",
    "4348": "新建项目群已提交审批！",
    "4349": "确认提取聊天记录的归属组织",
    "4350": "选择归属组织",
    "4351": "选择组织",
    "4352": "请选择组织",
    "4353": "选择订单",
    "4354": "请选择订单",
    "4355": "提取成功!",
    "4356": "支持 “多个文件” 另存为啦！！",
    "4357": "选择多个文件，点击另存为即可实现多文件一起另存至同 一路径下（讨论文件合集暂不支持多选另存）",
    "4358": "逐条转发",
    "4359": "合并转发",
    "4360": "文件另存为",
    "4361": "提取聊天记录",
    "4362": "解散该群后，所有群成员将失去和群内成员的联系，同时该群的聊天图片、文件也将被删除！",
    "4363": "退出后，不会再接收此群聊消息！",
    "4364": "移除后，{}将无法收到该群聊的消息!",
    "4365": "解散群聊",
    "4366": "退出群聊",
    "4367": "移除群成员",
    "4368": "您不是群主，没有权限修改",
    "4369": "修改群信息成功",
    "4370": "备注名(仅自己可见)",
    "4371": "置顶聊天",
    "4372": "转让群主",
    "4373": "手机或邮箱邀请",
    "4374": "您已重复添加此内容！",
    "4375": "已邀请加入群聊",
    "4376": "邀请",
    "4377": "邀请群成员",
    "4378": "所要加入群聊",
    "4379": "分享群链接或群二维码，成员可快速加入群聊，快来试试吧！",
    "4380": "【荣大智慧云】“{}”邀请您加入讨论组“{}”，点击下方链接即可加入。",
    "4381": "被邀请人通过链接登录/注册后加入群聊",
    "4382": "【荣大智慧云】“{}”邀请您加入讨论组“{}”, 点击下方链接即可加入",
    "4383": "群主",
    "4384": "获取群成员信息失败",
    "4385": "群成员列表",
    "4386": "转让群主-选择成员",
    "4387": "选择超出限制",
    "4388": "讨论组邀请",
    "4389": "项目邀请",
    "4390": "组织邀请",
    "4391": "荣大智慧云外链分享的文件，请查看",
    "4392": "【荣大智慧云】“{}”邀请您加入“{}”，点击链接立即申请加入吧！用荣大智慧云开启高效协作模式。",
    "4393": "【荣大智慧云】“{}”邀请您加入项目“{}”，点击下方链接即可加入",
    "4394": "组织加入成功",
    "4395": "非项目成员无此功能权限",
    "4396": "你可以联系项目创建人索取项目编码，申请加入对应的项目。",
    "4397": "也可以由此项目负责人邀请您加入项目。",
    "4398": "去联系项目创建人",
    "4399": "源文件已不存在，无法操作此项",
    "4400": "源文件所在位置",
    "4401": "查看来源位置",
    "4402": "没有匹配到任何结果",
    "4403": "选择已达上限",
    "4404": "你有新消息",
    "4405": "回到底部",
    "4406": "加载更多",
    "4407": "我的群组",
    "4408": "暂无评论...",
    "4409": "日志详情",
    "4410": "最近会话",
    "4411": "给对方留言（字数限制{}字）",
    "4412": "超过选择限制，不能选择",
    "4413": "没有找到关于“{}”的结果",
    "4414": "请选择开通权益的组织",
    "4415": "（仅支持自己创建的组织）",
    "4416": "您还没有自己创建的组织，无法匹配权益，请先创建自己的组织",
    "4417": "立即开通",
    "4418": "文件上传进度",
    "4419": "文件未全部上传，是否关闭界面并清空上传列表?",
    "4420": "({}人)",
    "4421": "请添加成员",
    "4422": "创建群聊成功",
    "4423": "添加成员成功",
    "4424": "在这里通过「复用已有日志」进行新建",
    "4425": "输入评论 (Enter 发送)，支持@组织内成员",
    "4426": "输入文字超出最长限制",
    "4427": "邀请链接：",
    "4428": "返回列表",
    "4429": "点击选择会计师事务所",
    "4430": "点击选择律师事务所",
    "4431": "点击选择资产评估机构",
    "4432": "点击选择信用评级机构",
    "4433": "点击选择券商机构",
    "4434": "请选择客户名称",
    "4435": "请输入主营业务",
    "4436": "输入五字以上进行模糊搜索",
    "4437": "未选择",
    "4438": "未配置**",
    "4439": "请填写必填项",
    "4440": "关联内容",
    "4441": "请输入搜索内容",
    "4442": "完 成",
    "4443": "项目底稿",
    "4444": "下载选中",
    "4445": "上传文件到此目录下",
    "4446": "当前目录下禁止拖拽上传",
    "4447": "今天的任务",
    "4448": "未完成任务",
    "4449": "任务前置",
    "4450": "当前任务[{}], 是否依赖审批结果?",
    "4451": "当前任务[{}], 是否取消依赖批结果?",
    "4452": "取消关联后，该文件将从「任务产出」中移除，确定要取消关联吗？",
    "4453": "选中的文件取消关联后，将从「任务产出」中移除，确定要取消关联吗？",
    "4454": "是否依赖此关联任务",
    "4455": "是否取消依赖此任务",
    "4456": "当前任务[{}], {}?",
    "4457": "关闭本次",
    "4458": "不再查看",
    "4459": "了解全部权益",
    "4460": "日志模板",
    "4461": "发布模板",
    "4462": "创建模板",
    "4463": "子任务",
    "4464": "是否删除{}子任务",
    "4465": "所有动态",
    "4466": "是否删除",
    "4467": "日志类型状态内容不能为空",
    "4468": "是否要删除",
    "4469": "任务模板编辑",
    "4470": "每{}月的第{}",
    "4471": "每{}月的第{}到{}结束",
    "4472": "每{}月的第{},重复{}次",
    "4473": "{}到{}",
    "4474": "{},重复{}次",
    "4475": "图片不允许再次发送",
    "4476": "文件不允许再次发送",
    "4477": "视频不允许再次发送",
    "4478": "音频不允许再次发送",
    "4479": "注：最多导入200行，不含表头，格式同下表",
    "4480": "注：荣大服务人员不会占用席位",
    "4481": "总计",
    "4482": "剩余可用席位:",
    "4483": "席位扩容",
    "4484": "Excel导入",
    "4485": "全部清空",
    "4486": "新增一行",
    "4487": "新增十行",
    "4488": "单次最多添加{}人，现已满{}人，不可添加。",
    "4489": "未识别到人员信息，请检查本地文件!",
    "4490": "添加模板内容",
    "4491": "下拉",
    "4492": "标题不能为空，请输入标题",
    "4493": "必填",
    "4494": "非必填",
    "4495": "单选",
    "4496": "选项",
    "4497": "请输入选项内容",
    "4498": "添加选项",
    "4499": "请输入选项内容，最多{}字",
    "4500": "输入不能超过{}字",
    "4501": "请输入标题，最多{}字",
    "4502": "使用此模板时默认抄送人不可被移除",
    "4503": "模板标题（必填）",
    "4504": "模板标题不能为空，请输入模板标题",
    "4505": "请输入模板标题，最多{}字",
    "4506": "需填写者输入内容",
    "4507": "编辑IP配置，配置人员在登录组织时，需要受控的IP环境下才能登录组织",
    "4508": "第一步：设置受控的公网IP地址（共两步）",
    "4509": "请输入规则名称",
    "4510": "IP 地址",
    "4511": "IP 说明：",
    "4512": "编辑后默认启用",
    "4513": "创建后默认启用",
    "4514": "保存进入下一步",
    "4515": "未输入规则名称",
    "4516": "未输入正确 IP 地址",
    "4517": "IP白名单地址已存在",
    "4518": "操作失败，请稍后再试",
    "4519": "您确认关闭弹窗吗? 点击 \"确定\" 将不会保留数据",
    "4520": "编辑受控人员，该人员在登录组织时，需要受控的IP环境下才能登录组织",
    "4521": "第二步：选择受控人员，该人员在登录组织时，需要在第一步受控的IP环境下才能登录组织",
    "4522": "搜索人员名称",
    "4523": "人员展示区",
    "4524": "手机号(必填)",
    "4525": "工作单位",
    "4526": "注：组织信息中，组织归属人不受组织安全规则配置限制",
    "4527": "是否清除所有人员?",
    "4528": "编辑 IP 配置",
    "4529": "编辑人员配置",
    "4530": "提交的举报暂不支持取消或者撤回，举报理由请您如实客观选择",
    "4531": "请选择举报理由",
    "4532": "补充描述",
    "4533": "请输入 {} 字以内的描述",
    "4534": "补充描述不能为空",
    "4535": "上传图片证据",
    "4536": "图片证据如：聊天截图或其它证明材料",
    "4537": "图片数量已超过 {} 张，不能再继续上传",
    "4538": "最少需要上传一张图片",
    "4539": "图片数量最大不能超过 {} 张",
    "4540": "图片列表",
    "4541": "违反国家法律法规",
    "4542": "未获得权利人的合法授权",
    "4543": "泄露商业机密",
    "4544": "侵犯个人隐私",
    "4545": "垃圾信息骚扰",
    "4546": "涉及未成年人有害信息（涉及未成年人有害信息举报专区）",
    "4547": "提交失败，信息不能为空",
    "4548": "您已举报成功，管理员将会在后台进行处理",
    "4549": "当前上传图片已超过最大限制，最多上传 {} 张图片",
    "4550": "消息接收人列表",
    "4551": "人已读",
    "4552": "已收听",
    "4553": "选择的消息为特殊类型消息，暂不支持转发",
    "4554": "选择的消息中，{}等特殊类型的消息暂不支持转发",
    "4555": "语音消息、群公告、聊天记录、任务消息、讨论文件合集等特殊类型的消息暂不支持转发",
    "4556": "继续转发",
    "4557": "转发后不显示内容",
    "4558": "消息转发",
    "4559": "转发成功",
    "4560": "单次短信加急可选5人，超过后默认以站内信方式进行发送",
    "4561": "短信接收人",
    "4562": "仅应用内 加急",
    "4563": "应用内+短信 加急",
    "4564": "公司名称",
    "4565": "人已收听",
    "4566": "全部已收听",
    "4567": "{}人执行",
    "4568": "（已选中{}项，共{}项）",
    "4569": "等{}人执行",
    "4570": "新建Word",
    "4571": "新建Excel",
    "4572": "新建PPT",
    "4573": "备注名",
    "4574": "当前已存在{}个名称为{}身份证与当前填写身份证一致的自然人客户{},该客户创建人为{} ，是否创建同名新客户？客户编码将作为该客户唯一标识",
    "4575": "任务类型消息",
    "4576": "聊天记录合集",
    "4577": "日志类型消息",
    "4578": "语音消息",
    "4579": "图文消息",
    "4580": "{}（{}人）",
    "4581": "您的设备暂不支持此功能，请使用文件或文件夹分别上传",
    "4582": "系统将为您检测是否安装过荣大XB插件，如果您没有安装过XB插件将为您自动安装，待安装后需您继续点击对应项目“数据中心”进行业务类型操作。",
    "4583": "文件上传准备中，请耐心等待...",
    "4584": "系统设置",
    "4585": "搜索({})",
    "4586": "文件正在回传，请稍后重试",
    "4587": "传输列表工作中也可关闭继续其他操作",
    "4588": "任务概览暂不支持下载文件夹",
    "4589": "外链分享记录",
    "4590": "文件分享记录",
    "4591": "银行流水线上平台",
    "4592": "银行流水线上平台权限",
    "4593": "有权在项目文档与底稿视图中查看该项目下的所有外链分享记录，同时拥有取消全部外链分享的权限",
    "4594": "解析权限",
    "4595": "可以对文件进行开始解析、暂停解析",
    "4596": "校对权限",
    "4597": "可以对文件进行校对、导出",
    "4598": "外链权限设置",
    "4599": "通过分享外链的「权限设置」功能，可以设置外链的「过期时间」、「访问密码」、「下载权限」",
    "4600": "在「外链分享记录」中，可查看历史外链详情，也可取消分享",
    "4601": "分享二维码",
    "4602": "已含有访问密码，扫码后无需再次输入",
    "4603": "文件外链：",
    "4604": "{} 通过「荣大智慧云」将“{}”文件分享给你，点击链接进行查看。{}",
    "4605": "{} 通过「荣大智慧云」将“{}”等文件分享给你，点击链接进行查看。{}",
    "4606": "{}\\n访问密码：{}",
    "4607": "已经加载到底啦",
    "4608": "过期时间",
    "4609": "7天",
    "4610": "30天",
    "4611": "永久有效",
    "4612": "共选择{}个文件",
    "4613": "访问密码",
    "4614": "无访问密码",
    "4615": "有访问密码",
    "4616": "系统默认生成访问密码",
    "4617": "下载权限",
    "4618": "允许下载",
    "4619": "禁止下载",
    "4620": "获得该文档链接的用户都可访问分享的相关文档",
    "4621": "链接有效期：",
    "4622": "访问密码：",
    "4623": "所有获得链接的用户都可查看",
    "4624": "到期后将无法访问此链接",
    "4625": "确定要进入「银行流水线上平台」吗？",
    "4626": "取消该文件的外链分享",
    "4627": "文件外链",
    "4628": "分享时间",
    "4629": "取消分享",
    "4630": "确定要取消外链分享吗？",
    "4631": "取消后在该外链中将无法查看此文件，确定要继续操作吗？",
    "4632": "取消后链接将全部失效，确定要继续操作吗？",
    "4633": "取消成功",
    "4634": "{} 访问密码：{}",
    "4635": "请输入操作人名称",
    "4636": "取消全部外链分享",
    "4637": "数量",
    "4638": "取消分享后拥有该链接的用户将无法继续查看分享的文件内容，确定要取消分享吗？",
    "4639": "是否通知执行人和抄送人?",
    "4640": "因当前空间不足，导致文件上传失败，请清理空间后重试。",
    "4641": "港股翻译",
    "4642": "IT数据中台线上平台",
    "4643": "管理员权限",
    "4644": "可以对文档进行校对、预览",
    "4645": "预览校对权限",
    "4646": "可以对文件进行校对、编辑、预览、导出",
    "4647": "文件名称暂不支持查看",
    "4648": "确定要进入「港股翻译」平台吗？",
    "4649": "确定要进入「IT数据中台线上平台」吗？",
    "4650": "项目属性",
    "4651": "请选择项目属性",
    "4652": "标签变动记录",
    "4653": "产品到期提醒",
    "4654": "前往充值",
    "4655": "会议已删除",
    "4656": "投票已删除",
    "4657": "正在加载，请稍等",
    "4658": "排序设置",
    "4659": "按创建时间",
    "4660": "按项目名称",
    "4661": "排序顺序",
    "4662": "倒序",
    "4663": "正序",
    "4664": "评论成功",
    "4665": "确定要删除评论吗？",
    "4666": "删除后将无法恢复，确定要继续删除评论吗？",
    "4667": "回复成功",
    "4668": "选区内容已被删除",
    "4669": "当前多选不支持此操作，请选择单个文件以查看版本",
    "4670": "客户关系",
    "4671": "性格特征",
    "4672": "擅长行业",
    "4673": "综合评价",
    "4674": "请输入客户关系",
    "4675": "请输入性格特征",
    "4676": "请选择擅长行业",
    "4677": "交接时间",
    "4678": "有新内容上线，点击完成更新",
    "4679": "更新信息",
    "4680": "执业岗位",
    "4681": "修改头像",
    "4682": "上传头像",
    "4683": "客户关系不能为空",
    "4684": "性格特征不能为空",
    "4685": "擅长行业不能为空",
    "4686": "YYYY年M月D日",
    "4687": "处理完成map",
    "4688": "查看上下文",
    "4689": "查看全部评论",
    "4690": "输入评论，支持@组织内成员",
    "4691": "任务成员",
    "4692": "IT数据中台项目：项目开通线上流水校对功能和RPA穿行测试功能",
    "4693": "IT数据中台项目",
    "4694": "Enter 发送",
    "4695": "输入内容超出字符限制，请控制在200字符以内",
    "4696": "更新版本时，已上锁文件将自动过滤，不进行重命名或更新",
    "4697": "申请查看联系人方式",
    "4698": "已被拒绝",
    "4699": "已终止授权",
    "4700": "授权有效期",
    "4701": "授权消息",
    "4702": "请选择项目类型",
    "4703": "当前授权已由他人完成",
    "4704": "请选择交易场所",
    "4705": "是否存在效力期限内与该项目有关的负面执业声誉信息",
    "4706": "请输入发行人",
    "4707": "请输入保荐机构",
    "4708": "获取官网数据",
    "4709": "人工录入数据",
    "4710": "新建项目经历",
    "4711": "编辑项目经历",
    "4712": "板块",
    "4713": "确定要删除该项目经历吗？",
    "4714": "联系人姓名:",
    "4715": "举报类型",
    "4716": "举报说明",
    "4717": "盗版、未获得权利人的合法授权",
    "4718": "举报成功",
    "4719": "可使用只读打开。确定要继续预览打开吗？",
    "4720": "下载可查看完整文件。确定要继续预览打开吗？",
    "4721": "安全中心",
    "4722": "已认证",
    "4723": "认证已过期",
    "4724": "您的实名认证已通过，有效期为",
    "4725": "注：认证到期或信息变更时，需要重新认证",
    "4726": "证件类型",
    "4727": "身份证",
    "4728": "更新认证",
    "4729": "立即认证",
    "4730": "真实姓名",
    "4731": "解绑",
    "4732": "证件证号",
    "4733": "请输入真实姓名",
    "4734": "请输入证件证号",
    "4735": "证件证号格式不正确，请检查后重新输入",
    "4736": "台湾来往大陆通行证",
    "4737": "港澳来往大陆通行证",
    "4738": "护照",
    "4739": "认证成功",
    "4740": "设置实名认证",
    "4741": "为满足监管要求，保障共享文件服务的安全合规，请进行实名认证以解锁全部功能",
    "4742": "关闭弹框后将退出登录，确定要取消实名认证吗？",
    "4743": "账号保护",
    "4744": "认证有效期",
    "4745": "申诉举报",
    "4746": "投诉举报",
    "4747": "未认证",
    "4748": "已过期",
    "4749": "本地编辑将调用本地对应文件的编辑器打开",
    "4750": "显示为「仅可预览」或「不可预览」的文件格式，不支持本地编辑",
    "4751": "验证失败，请重试",
    "4752": "填写信息",
    "4753": "认证完成",
    "4754": "如有问题，请拨打咨询电话-",
    "4755": "完成时间",
    "4756": "已显示全部子任务",
    "4757": "共 {} 项文件已全部显示",
    "4758": "审核期间可正常使用系统",
    "4759": "根据国家监管机构下发的相关监管要求，您提交的手机号疑似虚拟号码，我们将对您提交的信息进行人工审核，在此期间，您可以正常使用系统，若有监管审核需要，我们会及时与您联系核验信息，请您知晓",
    "4760": "\"{}\"正在进行在线编辑，于\"{}\"发起",
    "4761": "【图片】",
    "4762": "请选择任务标签",
    "4763": "动态提醒",
    "4764": "请选择动态提醒",
    "4765": "请输入任务内容,多个请用空格隔开",
    "4766": "当 更新时间",
    "4767": "且 操作人员",
    "4768": "且 操作内容",
    "4769": "请输入操作内容",
    "4770": "字段配置",
    "4771": "新增字段配置",
    "4772": "补充更多任务维度字段，可按需勾选展示字段，灵活自定义任务列表，聚焦关注信息",
    "4773": "好的",
    "4774": "任务创建时间",
    "4775": "精准筛选任务，多条件组合快速定位所需",
    "4776": "将为本项目开启IT数据中台功能",
    "4777": "可访问数据（荣大专用）",
    "4778": "任务新动态，在名称后红点提示",
    "4779": "无项目",
    "4780": "RD 码：",
    "4781": "{} 通过「荣大智慧云」将“{}”文件分享给你，请在三方协作系统中输入 RD 码完成文件同步：{}",
    "4782": "{} 通过「荣大智慧云」将“{}”等文件分享给你，请在三方协作系统中输入 RD 码完成文件同步：{}",
    "4783": "RD 码复制成功",
    "4784": "RD 码复制失败"
}
